import type {
  _SelectionClippingType,
  EditMode,
  FilterClick,
  HeaderClick,
  OvlSysColumn,
  Paging,
  RangeFilterType,
  RowFunctionResultToSet,
  RowState,
  SaveMode,
  SelectRowDef,
  SelectRowDefMode,
  SortClick,
  StaticFilter,
  SYSTableData,
  SYSTableDef,
  TableDataAndDef,
  /*Tabs,*/
} from "./table"
import {
  _TableGetGroupInitAggregateResult,
  _TableGroupCalcAggregate,
} from "./table"

import type {
  SYSAction,
  SYSActions,
  SYSForm,
  SYSState,
  SYSTableDefIds,
} from "../../"
import {
  HookFormAdd_ReturnType,
  HookFormAdd_Type,
  HookTableAfterDelete_Type,
  HookTableAfterSave_Type,
  HookTableBeforeDelete,
  HookTableBeforeDelete_ReturnType,
  HookTableBeforeDelete_Type,
  HookTableBeforeSave_ReturnType,
  HookTableBeforeSave_Type,
  HookTableDeleteError_Type,
  HookTableFn,
  HookTableFn_Type,
  HookTableRowFn_Type,
  HookTableRowFnCan_Type,
  HookTableRowsAfterRebuild,
  HookTableRowsAfterRebuild_Type,
  HookTableSaveError_Type,
  HookTableSchemaAssign,
  HookTableSchemaAssign_Type,
  HookTableServerBeforeMergeRow,
  HookTableServerData,
  HookTableServerData_Type,
  RowFnConfirmContentFieldsReset_Type,
  ServerData_ChangedType,
  TableRowFnProcessRawFeedback_Type,
} from "../../global/hooks"

import type { AppDefProcess } from "../../config"

import { postRequest } from "../../effects"
import { SYSSeqId, T, UIContextType } from "../../global/globals"
import {
  HookFormAdd,
  HookTableAfterDelete,
  HookTableAfterSave,
  HookTableBeforeSave,
  HookTableDeleteError,
  HookTableGroupCalcValue,
  HookTableGroupValue,
  HookTableRowFn,
  HookTableRowFnCan,
  HookTableSaveError,
} from "../../global/hooks"

import { html, ovl, SYSConfig } from "../../"

import {
  DialogCurrentState,
  DialogIsOpen,
  DialogOk,
  DialogOkCancel,
  DialogOpen,
} from "../dialog/dialogapi"
import { InitFormType, SYSFormState } from "../forms/actions"

import {
  ProcessEnd,
  ProcessIsRunning,
  ProcessRunningChangeSnack,
  ProcessStart,
} from "../longrunningprocesstracker/processapi"
import { SnackAdd, SnackTrackedReplaceContent } from "../snackapi"
import {
  _AddRowToDisplayedArray,
  _cachedFieldLists,
  _DoRebuildAndFixPage,
  _DoRowFnProcessRunningCheck,
  _DoServerDataConversionSyncAndBuildUpRebuildAndChangedInfo,
  _EnrichColumnsFromSchema,
  _GetActiveInactiveForcedFilterCustom,
  _GetForcedColumnFiltersKeys,
  _GetFilterSortDifferentiator,
  _GetFnResultToSet,
  _GetRowFnToSet,
  _GetTableDialogTitle,
  _handleRowFnConfirmFieldsReset,
  _handleRowFnEndpointData,
  _handleRowFnTracking,
  _MergeRowHookParamsType,
  _ResetFilters,
  _ResetSort,
  _RowFnConfirmFormHelper,
  _TableFilterFn,
  _TableRefreshServerData,
  _tableRowFnSetHelper,
  _TableSetColumnVisibility,
  DoRefreshLookups,
  getFormFieldsFromColumns,
  GetTableKeys,
  initTableState,
  setTableNeedsRefresh,
  TableSortFn,
} from "../table/helpers"
import { deleteTableRow /*setTableRow*/ } from "./helpers"

import {
  FormGet,
  FormInit,
  FormIsDirty,
  FormSetUnDirty,
} from "../forms/formapi"
import { ScreenCurrentState } from "../screenapi"
import { _FocusState } from "../sysbaseelement"
import {
  _ForcedFilters,
  _TableAddRowReturnType,
  _TableFormCloseEditRow,
  TableAttributeFilter,
  TableColumnFilter,
  TableCustomFilter,
  TableGet,
  TableInit,
  TableRebuild,
  TableRefresh,
  TableRemoveRowFromData,
  TableSchemaGet,
  TableSelectRow,
} from "./tableapi"
import { _HeaderMenuFilterFields } from "./tablerowheadermenu/tablesettings/formdef"

import { Data } from "../../dataapi"
import { FocusSet } from "../../global/globalapi"
import { filterSortStore } from "../../offlinestorage"
import { _TableRowEditFormType } from "../../state"
import { FieldIsDirty } from "../forms/fieldapi"
import { sortedReplacer } from "../forms/helper"
import { ValidationsAdd } from "../forms/validatorsapi"
import {
  _ProcessReturnType,
  ProcessSnackType,
} from "../longrunningprocesstracker/longrunningprocesstracker"
import { SnackState } from "../snack/snack"
import {
  _FilterChangedComparedToDefault,
  _GetCurrentActiveTableSettingsFilterSortJsonString,
  _GetFilterSortPermission,
  _SetCurrentActiveTableSettingsFilter,
} from "./tablerowheadermenu/tablesettings/helpers"

const minimumFilterChars = 3

export const _TableSetPage: SYSAction<{ paging: Paging; page: number }> = (
  pageDef
) => {
  if (pageDef.page > -1) {
    pageDef.paging.page = pageDef.page
  }
}

export const _TableFilterSelected: SYSAction<TableDataAndDef> = (
  value,
  { global }
) => {
  let actions = global.getActions()
  let def = value.def
  def.uiState.filter.filter.showSelected =
    !def.uiState.filter.filter.showSelected
  actions.ovl.internal._TableSetPage({
    paging: value.def.uiState.paging,
    page: 0,
  })
  TableRebuild(def.id, { showProcess: true })
}

export const _TableSelectHeader: SYSAction<HeaderClick> = async (
  def,
  { global }
) => {
  let state = global.getState()
  let actions = global.getActions()
  if (!def.def.initialised) {
    await TableInit(def.def.id)
  }

  def.def.uiState.headerSelected = def.key
  // if (def.key === "") {
  //   state.ovl.dialogs.TableHeaderMenu.isClosing = true
  // }
}

export const _TableSort: SYSAction<SortClick> = (value) => {
  let def = value.def

  def.uiState.sort.sort.field = value.key
  if (value.ascending) {
    def.uiState.sort.sort.direction = "asc"
  } else {
    def.uiState.sort.sort.direction = "desc"
  }
  def.uiState.sort.sort.useValue = value.useValue === true
  def.uiState.sort.sortCustom.selected = ""
}

export const _TableFilter: SYSAction<FilterClick> = (value, { global }) => {
  let actions = global.getActions()
  let def = value.def

  def.uiState.filter.filter.value = value.value
  def.uiState.filter.filter.showSelected = false

  if (value.def.options.rendering.tableControls.page.visible) {
    actions.ovl.internal._TableSetPage({
      paging: value.def.uiState.paging,
      page: 0,
    })
  }
  TableRebuild(def.id, { showProcess: true })
  //actions.ovl.table._TableRefresh({ defId: value.def.id, data: value.data })
}

export const _TableSelectAll: SYSAction<{
  tableDefId: SYSTableDefIds

  select: boolean
}> = (def) => {
  let table = TableGet(def.tableDefId)
  let selectedRows = table.def.uiState.selectedRow
  let keys = table.getKeys()
  //let count = keys.length
  keys.forEach((k) => {
    selectedRows[k].selected = def.select
    if (!def.select) {
      selectedRows[k].showNav = false
    }
  })
}

// export const _TableSetViewTab: SYSAction<{ def: Tabs; key: number }> = (
//   value
// ) => {
//   value.def.view.selected = value.key
// }

export const _TableSelectRow: SYSAction<SelectRowDef> = (selectRow) => {
  let def = selectRow.def
  let selRows = def.uiState.selectedRow
  let sel = selRows[selectRow.key]
  let multiselect = def.features.multiSelect
  // prepare
  Object.keys(selRows).forEach((f) => {
    selRows[f].showNav = false
    if (!multiselect) {
      if (selRows[f].selected && f !== selectRow.key) {
        selRows[f].selected = false
      }
    }
  })

  // toggle selected state
  let mode: SelectRowDefMode = "Mode1"
  if (selectRow.options?.mode) {
    mode = selectRow.options.mode
  }
  let keys = [selectRow.key]
  if (multiselect && selectRow.options?.modifiers?.ctrlKey) {
    // if the shiftkey was pressed we would like to select multiple keys
    // start is the last one selected above the current pos
    // end is the current pos
    // so get all the keys of those guys and save em

    let currentIdx = def.uiState.dataFilteredAndSorted.indexOf(selectRow.key)

    let closestIdx = 0
    if (currentIdx > 0) {
      for (let idx = currentIdx - 1; idx >= 0; idx--) {
        let k = def.uiState.dataFilteredAndSorted[idx]
        if (selRows[k].selected) {
          closestIdx = idx
          break
        }
      }
    }
    keys = def.uiState.dataFilteredAndSorted.slice(closestIdx, currentIdx + 1)
    mode = "Select"
  }

  //}
  if (mode === "Mode1") {
    if (!sel.selected) {
      sel.selected = true
      def.uiState.selectedCounter++
      sel.count = def.uiState.selectedCounter
      sel.showNav = true
    } else {
      sel.selected = false
      sel.showNav = false
    }
  } else if (mode === "Select") {
    keys.forEach((k, i) => {
      sel = selRows[k]
      sel.selected = true
      def.uiState.selectedCounter++
      sel.count = def.uiState.selectedCounter
      if (i === keys.length - 1) {
        sel.showNav = true
      }
    })
  } else if (mode === "Unselect") {
    sel.selected = false
    sel.showNav = false
  }
}
export const _TableRefreshDataFromServer: SYSAction<{
  def: SYSTableDef
  data: SYSTableData
  localData?: any[]
  serverFilter?: {}
  localDataSync?: _LocalDataSyncType
  ignoreNeedsRefresh?: boolean
}> = async (value, { global }) => {
  let state = global.getState()
  let actions = global.getActions()
  let def = value.def
  if (
    !value.localData &&
    state.ovl.app.offline.api &&
    SYSConfig.offline.enabled
  ) {
    return
  }
  let columns = def.columns
  let staticFilter = def.uiState.filter.filter.static
  let getSchema = false
  let res
  let filter = value.serverFilter
  let onlyServerFilter
  if (value.serverFilter) {
    onlyServerFilter = JSON.parse(JSON.stringify(value.serverFilter))
  }

  let localDataSync: _LocalDataSyncType = value.localDataSync
  if (!value.localData) {
    if (
      !def.uiState?._schemaRetrieved &&
      (!value.data.schema || Object.keys(value.data.schema).length === 0) &&
      def.database?.useSchema === true
    ) {
      getSchema = true
    }

    if (filter === undefined) {
      filter = {}
    }
    Object.keys(staticFilter).forEach((k) => {
      if (filter[k] === undefined) {
        filter[k] = staticFilter[k]
      }
    })

    let screenCurrentState = ScreenCurrentState()
    let uiContext: UIContextType = {
      feature: <string>def.feature,
      tableDefId: def.id,
      formType: undefined,
      formId: undefined,

      screen: screenCurrentState?.screen,
      screenInstance: screenCurrentState?.instance,
    }
    let postData = {
      lang: state.ovl.session.Language,
      getSchema,
      applyEntityFilter: def.database.applyEntityFilter !== undefined,
      insertMode: def.database.dbInsertMode,
      filter,
      uiContext,
    }
    try {
      res = await Data(def.server.endpoint + "/get", postData)
      if (def.database.useSchema) {
        def.uiState._schemaRetrieved = true
      }
    } catch (err) {
      // this is currently just a temporary fix for when endpoints are not ready for the SchemaGet
      if (def.database.useSchema && err.status === 400) {
        def.uiState._schemaRetrieved = true
      }
      if (err.status === 449 && SYSConfig.offline.enabled) {
        SnackAdd("Offline", "Information")
        return
      } else {
        throw err
      }
    }

    // sync needsRefresh with eventually other tables
  } else {
    // sanitize localData
    // shouldn't contain undefined
    // make it null in that case

    // we need the schema in any case
    await TableSchemaGet(def.id)
    value.localData.forEach((f) => {
      Object.keys(f).forEach((colKey) => {
        if (f[colKey] === undefined) {
          f[colKey] = null
        }
      })
    })
    if (def.server.endpoint && !value.localDataSync) {
      // if it is an server fed table. but used locally. then most probably the user just wants to refresh some rows..
      // use case klt_portal_time. websockets does update efforts and uses the refresh with the data from the websocket as localdata
      localDataSync = "MergeOnly"
    }
    res = { data: { data: value.localData } }
  }

  if (!res.data) {
    return
  }

  // indicate if there is more data on server
  // important if user filter/sorts in table and expects new data is pulled which is not the case
  // we always have our working set....
  if (res.data.more) {
    value.data.hasMoreDataOnServer = true
  } else {
    value.data.hasMoreDataOnServer = false
  }
  if (
    (!value.data.schema || Object.keys(value.data.schema).length === 0) &&
    getSchema
  ) {
    value.data.schema = res.data.schema
    if (!value.data.schema) {
      // we need a ref
      value.data.schema = {}
    }

    let fn = actions.app.features?.[def.feature]?.hooks?.[HookTableSchemaAssign]
    if (fn) {
      await fn(<HookTableSchemaAssign_Type>{
        tableDefId: def.id,
        schemaToSet: value.data.schema,
      })
    }
    // if its still undefined mark is as null that means it doesn't get retrieved anymore
    if (!value.data.schema) {
      value.data.schema = {}
    }
  }
  if (!localDataSync) {
    // its refresh only if the user provided localdata
    localDataSync = "SyncWithinFilter"
  }
  await _TableRefreshDataFromServerHelper(
    res,
    def,
    value.data,
    localDataSync,
    onlyServerFilter,
    value.ignoreNeedsRefresh
  )
}

export type _LocalDataSyncType = "ReplaceAll" | "SyncWithinFilter" | "MergeOnly"

export const _TableRefreshDataFromServerHelper = async (
  res: any,
  def: SYSTableDef,
  data: SYSTableData,
  localDataSync: _LocalDataSyncType,
  serverFilter?: any,
  ignoreNeedsRefresh?: boolean
) => {
  if (!res.data.data) {
    console.error("Ovl needs a data property on the result!")
    return
  }

  //let startD = new Date().getTime()

  let state = ovl.getState()
  let actions = ovl.getActions()
  let columns = def.columns

  data.ext = res.data.ext

  if (res.data.tableDefs) {
    Object.keys(res.data.tableDefs).forEach((k) => {
      if (data.tableDef[k]) {
        data.tableDef[k].defFromServer = res.data.tableDefs[k]
      }
    })
  }

  let formState
  if (def.uiState.formId) {
    formState = state.ovl.forms[def.uiState.formType][def.uiState.formId]
  }

  let serverData: any[] = res.data.data

  if (def.server.endpoint) {
    DoRefreshLookups(actions, def, serverData, formState)
  }

  let idfield = def.database.dataIdField

  // create hashsets for faster processing...
  let keysFromServer = new Map<string, number>()

  let ovlLineNumId = idfield === "@@OvlLineNum"

  serverData.forEach((f, i) => {
    if (ovlLineNumId) {
      f[idfield] = i
    }
    keysFromServer.set(f[idfield], i)
  })
  let localData = data.data

  let validLocalDataKeys = Object.keys(localData).filter(
    (f) => (localData[f].OvlSysState as OvlSysColumn).rowState.state !== "Add"
  )

  let localKeys = new Map<any, string>()
  let localKeysToId = new Map<string, any>()
  validLocalDataKeys.forEach((f) => {
    let id = localData[f][idfield]
    localKeys.set(id, f)
    localKeysToId.set(f, id)
  })

  //  let needsRefreshBecauseOfAdded = false
  // check if rows were added meanwhile
  let keysArrayFromServer = Array.from(keysFromServer.keys())

  // needsRefreshBecauseOfAdded = keysArrayFromServer.some(
  //   (k) => !localKeys.has(k)
  // )

  // delete check is not needed its handled by design
  // check if rows were deleted meanwhile
  let rowsDeleted = false
  let rowSysState: OvlSysColumn

  let staticFilter = def.uiState.filter.filter.static
  let hasClientDataFirstKey =
    localKeysToId.size > 0 ? localKeysToId.keys().next().value : undefined
  Object.keys(staticFilter).forEach((k) => {
    // if the staticFilter Column is not in the result remove it from static filter
    // UseCase: BAR Attachments, one client deletes, the other refreshes same attachments and should see the result
    // but in The TableRefresh there we also submit ObjId and ObjType as a staticFilter which is not on the result set
    // remember: As long as only using staticFilter for a refresh we get the mode "RefreshAndRemove..." here.
    // we always clean staticFilter of columns which are not in result (if we have server or clientdata to compare)

    let hasServerData = serverData[0] !== undefined
    let deleteStaticFilterColumn = false
    if (hasServerData) {
      // if we got columns from server but if the staticFilter-column as defined is not in there  -> delete staticFilter Column
      deleteStaticFilterColumn = serverData[0][k] === undefined
    } else {
      let hasClientData = localKeysToId.size > 0
      if (hasClientData) {
        // if we don't have columns from server we can also check eventually existing ones on client
        // if the staticFilter-column as defined is not in those local columns -> delete staticFilter Column
        deleteStaticFilterColumn =
          localData[hasClientDataFirstKey][k] === undefined
      }
    }
    if (deleteStaticFilterColumn) {
      delete staticFilter[k]
    }
  })

  if (localDataSync === "SyncWithinFilter" || localDataSync === "ReplaceAll") {
    // to check if something is deleted we need to check the local ids with the ids delivered by the server
    // if there is an local id which is not in the server id then the row needs to be deleted
    // only if the result is a known set (staticFilter and eventually submitted serverFilter from DataRefresh) and complete do the automatic deletion

    if (!serverFilter || localDataSync === "ReplaceAll") {
      serverFilter = {}
    }

    Object.keys(serverFilter).forEach((k) => {
      // We do a cleanup of the server filter
      // we can just comapre and remove depending on serverFilter if the result has the column in question
      let hasServerData = serverData[0] !== undefined
      let deleteFilterColumn = false
      if (hasServerData) {
        // if we got columns from server but if the Filter-column as defined is not in there  -> delete Filter Column
        deleteFilterColumn = serverData[0][k] === undefined
      } else {
        let hasClientData = localKeysToId.size > 0
        if (hasClientData) {
          // if we don't have columns from server we can also check eventually existing ones on client
          // if the Filter-column as defined is not in those local columns -> delete Filter Column
          deleteFilterColumn = localData[hasClientDataFirstKey][k] === undefined
        }
      }
      if (deleteFilterColumn) {
        delete serverFilter[k]
      }
    })
    Object.assign(serverFilter, staticFilter)
    let allFilterKeys = Object.keys(serverFilter)
    let keysToDelete = validLocalDataKeys
      .filter((f) =>
        allFilterKeys.every((f2) => localData[f][f2] === serverFilter[f2])
      )
      .filter((k2) => {
        rowSysState = data.data[k2].OvlSysState as OvlSysColumn
        // if the localKey is not anymore in the serverResult we can remove it from localdata as well
        if (!keysFromServer.has(localKeysToId.get(k2))) {
          if (rowSysState.rowState.state === "Update") {
            SnackAdd(
              "Another User deleted a row you are currently working on...",
              "Error"
            )
            return false
          } else {
            return true
          }
        }
        return false
      })

    if (keysToDelete.length > 0) {
      rowsDeleted = true
      let threshold = Object.keys(localData).length * 0.8
      if (keysToDelete.length > 50 && keysToDelete.length >= threshold) {
        let keysToDeleteSet = new Set(keysToDelete)
        let keepKeys = Object.keys(localData).filter(
          (k) => !keysToDeleteSet.has(k)
        )

        Object.keys(data.tableDef).forEach((k) => {
          let tDef = data.tableDef[k] as SYSTableDef
          if (!tDef.uiState) return

          let oldHeaderBreaks = tDef.uiState.tableGroupHeaderBreaks
          let oldFooterBreaks = tDef.uiState.tableGroupFooterBreaks
          let oldResults = tDef.uiState.tableGroupResults

          tDef.uiState.tableGroupHeaderBreaks = {}
          tDef.uiState.tableGroupFooterBreaks = {}
          tDef.uiState.tableGroupResults = {}

          keepKeys.forEach((kk) => {
            if (oldHeaderBreaks[kk])
              tDef.uiState.tableGroupHeaderBreaks[kk] = oldHeaderBreaks[kk]
            if (oldFooterBreaks[kk])
              tDef.uiState.tableGroupFooterBreaks[kk] = oldFooterBreaks[kk]
            if (oldResults[kk])
              tDef.uiState.tableGroupResults[kk] = oldResults[kk]
          })

          keysToDelete.forEach((dk) => {
            tDef.uiState.rebuild.deletedKeys[dk] = true
          })
        })

        let oldSelected = def.uiState.selectedRow
        def.uiState.selectedRow = {}
        keepKeys.forEach((kk) => {
          if (oldSelected[kk]) def.uiState.selectedRow[kk] = oldSelected[kk]
        })

        let oldIndex = data.index
        let oldData = data.data

        data.index = {}

        data.data = {}
        localData = data.data

        keepKeys.forEach((kk) => {
          data.data[kk] = oldData[kk]
          let rowId = oldData[kk][idfield]
          data.index[rowId] = kk
        })
      } else {
        keysToDelete.forEach((k2) => deleteTableRow({ def, data }, k2))
      }
    }
  }

  let returnedKeys = new Map<string, ServerData_ChangedType>()
  let mergeRowHookParams: _MergeRowHookParamsType
  let mergeFn =
    actions.app.features[def.feature]?.hooks?.[HookTableServerBeforeMergeRow]
  if (mergeFn) {
    mergeRowHookParams = { defId: def.id, fn: mergeFn, tableData: data }
  }
  keysArrayFromServer.forEach((k) => {
    let dataKey = localKeys.get(k)
    let isAdd = false
    if (!dataKey) {
      dataKey = SYSSeqId()
      localData[dataKey] = { OvlSysState: _GetOvlSysColDefault() }
      def.uiState.selectedRow[dataKey] = {
        count: 0,
        selected: false,
        showNav: false,
      }
      isAdd = true
    }

    let changed: ServerData_ChangedType = { columns: {}, isAdd }
    let i = keysFromServer.get(k)
    let sd = serverData[i]
    rowSysState = localData[dataKey].OvlSysState as OvlSysColumn
    if (!rowSysState) {
      localData[dataKey].OvlSysState = _GetOvlSysColDefault()
      rowSysState = localData[dataKey].OvlSysState
    }
    data.index[sd[idfield] as string] = dataKey
    rowSysState.rowState.originalId = sd[idfield]
    changed = _DoServerDataConversionSyncAndBuildUpRebuildAndChangedInfo(
      dataKey,
      data.clientConversion,
      serverData[i],
      localData[dataKey],
      def.uiState.rebuild,
      isAdd,
      mergeRowHookParams,
      data.checkForOtherModification
    )
    if (Object.keys(changed.columns).length > 0) {
      returnedKeys.set(dataKey, changed)
    }
  })
  _DoRebuildAndFixPage(def, false, ignoreNeedsRefresh)
  data.timestamp = Date.now()
  let fn = actions.app.features?.[def.feature]?.hooks?.[HookTableServerData]
  if (fn) {
    await fn(<HookTableServerData_Type>{
      ext: res.data.ext,
      more: res.data.more,
      tableDefId: def.id,
      tableData: data,
      returnedKeys,
      type: "RefreshData",
    })
  }

  //let endD = new Date().getTime()

  // SnackAdd(
  //   `TableRefreshDataFromServer ${def.id} took ${(endD - startD) / 1000} seconds...`
  // )
}

export type TableInitResetStrategy = {
  ClearDataView?: boolean
  ClearData?: boolean
  Filter?: boolean
  Sort?: boolean
  Selection?: boolean
  Columns?: boolean
  Page?: boolean
}
export type TableInitType = {
  defId: SYSTableDefIds
  data: SYSTableData
  resetStrategy?: TableInitResetStrategy
  staticFilter?: StaticFilter
}
export const _GetOvlSysColDefault = (): OvlSysColumn => {
  return {
    editRow: { mode: undefined, selected: false },
    /*selectedRow: { selected: false, showNav: false, count: 0 },*/
    fnFeedback: {},
    rowState: {
      state: "Ok",
      originalId: undefined,
      // if a row gets changed isnide a tabledef id (view), selection fn needs to know to which it belongs.
      // because according static filter it could be out of scope but needs to be there up to the next rebuild
      // usecase: BAR Activities. BP Filter CardCode. Then add an activity with a different cardCode. Then this row still belongs to this tabledefid when selection is made
      lastChangeBelongsToTableDefId: undefined,
    },
    lastFeedbackTS: 0,
  }
}

export const _TableInit: SYSAction<TableInitType> = async (
  value,
  { global }
) => {
  let state = global.getState()
  let actions = global.getActions()
  let dataAndState = value.data
  let def = dataAndState.tableDef[value.defId]
  let rs = value.resetStrategy
  await initTableState(def, dataAndState, value.defId, rs?.Columns === true)
  if (value.staticFilter) {
    // force filter
    value.staticFilter = JSON.parse(JSON.stringify(value.staticFilter))
    def.options.initial_filter.static = value.staticFilter
    def.uiState.filter.filter.static = value.staticFilter
  }
  //def.initialised = true

  if (rs) {
    if (rs.ClearDataView) {
      def.uiState.currentlyAddingKey = undefined
      def.uiState.dataFilteredAndSorted = []

      def.uiState.tableGroupHeaderBreaks = {}
      def.uiState.tableGroupFooterBreaks = {}
      def.uiState.tableGroupResults = {}
      def.uiState.selectedCounter = 0
      def.uiState.selectedRow = {}
      def.uiState.headerSelected = ""
      setTableNeedsRefresh(def, false)
      def.uiState.rebuild.addedKeys = {}
      def.uiState.rebuild.deletedKeys = {}
      def.uiState.rebuild.updatedKeys = {}
      def.uiState.rebuild.changed = {}
      def.uiState.rowsCount = 0

      let keysToReset = Object.keys(value.data.data)
      keysToReset.forEach((k) => {
        value.data.data[k].OvlSysState = _GetOvlSysColDefault()
      })

      //def.uiState.viewRow = {}
      def.uiState.paging = JSON.parse(
        JSON.stringify(def.options.initial_paging)
      )
    }
    if (rs.ClearData) {
      // set default values
      dataAndState.index = {}
      dataAndState.offline = {
        addedKeys: {},
        deletedKeys: {},
        errors: {},
        updatedKeys: {},
        offlineHandlerInProcess: false,
      }
      dataAndState.offlineSeq = 0
      dataAndState.timestamp = 0
      dataAndState.lastFetchParamsString = undefined

      dataAndState.data = {}

      Object.keys(dataAndState.tableDef).forEach((k) => {
        let tableDef = <SYSTableDef>dataAndState.tableDef[k]
        let uiState = tableDef.uiState
        if (uiState) {
          uiState.currentlyAddingKey = undefined
          uiState.dataFilteredAndSorted = []
          uiState.tableGroupResults = {}
          uiState.tableGroupHeaderBreaks = {}
          uiState.tableGroupFooterBreaks = {}
          uiState.selectedCounter = 0
          uiState.headerSelected = ""
          setTableNeedsRefresh(tableDef, false)
          uiState.rebuild.addedKeys = {}
          uiState.rebuild.deletedKeys = {}
          uiState.rebuild.updatedKeys = {}
          uiState.rebuild.changed = {}
          uiState.selectedRow = {}
          uiState.rowsCount = 0
          //uiState.viewRow = {}
          uiState.paging = JSON.parse(
            JSON.stringify(tableDef.options.initial_paging)
          )
        }
      })
    }
    if (rs.Filter) {
      await _ResetFilters(def)
    }
    if (rs.Sort) {
      _ResetSort(def)
    }
    if (rs.Selection) {
      def.uiState.selectedRow = {}
    }
    if (rs.Page) {
      def.uiState.paging.page = 0
    }

    def.uiState._resetStrategyForPersistFilterSort = rs
  }
}

export type TableRefreshType<RowType = any> = {
  ignoreRefreshedMessageSnack?: boolean
  refreshServerDataIfOlderThan?: number
  forceServerDataRefresh?: boolean
  localData?: any[]
  serverFilter?: {}
  forcedFilters?: _ForcedFilters<RowType>
  defId: SYSTableDefIds
  data: SYSTableData
  doNotRebuild?: boolean
  localDataSync?: _LocalDataSyncType
  enableFilterSortPersist?: boolean
  ignoreNeedsRefresh?: boolean
}
export const _TableRefresh: SYSAction<TableRefreshType<any>> = async (
  value,
  { global }
) => {
  let actions = global.getActions()
  let dataAndState = value.data
  let def = dataAndState.tableDef[value.defId]

  await initTableState(def, dataAndState, value.defId)

  // if (!value.localData && !def.server.endpoint) {
  //   def.initialised = true
  //   return
  // }
  if (value.forcedFilters?.staticFilter) {
    value.forcedFilters.staticFilter = JSON.parse(
      JSON.stringify(value.forcedFilters.staticFilter)
    )
    //def.uiState._oldStaticFilter = JSON.stringify(def.uiState.filter.filter.static
    def.uiState.filter.filter.static = value.forcedFilters.staticFilter
  }

  if (value.serverFilter) {
    value.serverFilter = JSON.parse(JSON.stringify(value.serverFilter))
  }

  let ignoreRefreshedMessageSnack = value.ignoreRefreshedMessageSnack
  let forceServerDataRefresh = value.forceServerDataRefresh
  let refreshedBecauseOfAge = false
  if (!forceServerDataRefresh) {
    let refreshServerDataIfOlderThan = value.refreshServerDataIfOlderThan
    if (!def.dataFetching.useCustomDataFetching) {
      if (refreshServerDataIfOlderThan) {
        def.features.forceFreshServerDataIfOlderThan =
          refreshServerDataIfOlderThan
      } else {
        if (def.features.forceFreshServerDataIfOlderThan) {
          refreshServerDataIfOlderThan =
            def.features.forceFreshServerDataIfOlderThan
        }
      }
      refreshedBecauseOfAge =
        refreshServerDataIfOlderThan > 0 &&
        dataAndState.timestamp + refreshServerDataIfOlderThan * 1000 <
          Date.now()

      if (refreshedBecauseOfAge) {
        forceServerDataRefresh = true
      }
    }
  }

  // Check if params changed for preferCache
  let expectedFilter: any = value.serverFilter
    ? JSON.parse(JSON.stringify(value.serverFilter))
    : {}
  let currentStaticFilter = def.uiState.filter.filter.static || {}
  Object.keys(currentStaticFilter).forEach((k) => {
    if (expectedFilter[k] === undefined) {
      expectedFilter[k] = currentStaticFilter[k]
    }
  })
  let currentFetchParamsString = JSON.stringify(expectedFilter, sortedReplacer)

  if (
    !forceServerDataRefresh &&
    dataAndState.lastFetchParamsString !== undefined
  ) {
    if (currentFetchParamsString !== dataAndState.lastFetchParamsString) {
      forceServerDataRefresh = true
    }
  }

  if (forceServerDataRefresh) {
    dataAndState.lastFetchParamsString = undefined
  }

  let willFetchFromServer =
    !dataAndState.timestamp || value.localData || !!forceServerDataRefresh

  if (
    willFetchFromServer &&
    (refreshedBecauseOfAge || !ignoreRefreshedMessageSnack)
  ) {
    ProcessStart("SYSTableRefresh", { snack: { type: "BusyIndicator" } })
  } else {
    ProcessStart("SYSTableRefresh")
  }
  try {
    if (
      !def.dataFetching.useCustomDataFetching &&
      (def.server.endpoint || value.localData)
    ) {
      let timestampBefore = dataAndState.timestamp
      await _TableRefreshServerData(
        def,
        dataAndState,
        actions,
        forceServerDataRefresh,
        value.localData,
        value.serverFilter,
        value.localDataSync,
        value.ignoreNeedsRefresh
      )
      if (
        willFetchFromServer &&
        !value.localData &&
        def.server.endpoint &&
        dataAndState.timestamp &&
        dataAndState.timestamp !== timestampBefore
      ) {
        dataAndState.lastFetchParamsString = currentFetchParamsString
      }
    }
    if (!value.doNotRebuild && !def.isTemplate) {
      //def.initialised = true
      await TableRebuild(def.id, {
        showProcess: !ignoreRefreshedMessageSnack,
        enableFilterSortPersist: value.enableFilterSortPersist,
        forcedFilters: value.forcedFilters,
      })
    } else {
      _EnrichColumnsFromSchema(value.data, def)
    }
  } finally {
    ProcessEnd("SYSTableRefresh")
  }
}
//let lastRebuildIndicator = 0
export const _TableRebuild: SYSAction<{
  defId: string
  data: SYSTableData
  showProcess?: boolean
  forcedFilters?: _ForcedFilters
  enableFilterSortPersist?: boolean

  selectionClipping?: _SelectionClippingType
}> = async (value, { global }) => {
  let state = global.getState()
  let actions = global.getActions()
  let def = <SYSTableDef>value.data.tableDef[value.defId]
  if (def.isTemplate) {
    return
  }
  let data = value.data.data
  if (!def.initialised) {
    await initTableState(def, value.data, def.id, false)
  }
  _EnrichColumnsFromSchema(value.data, def)
  let fn = actions.app.features[def.feature]?.hooks
  let appDefProcess: AppDefProcess

  // let dt = new Date().getTime()
  // // make sure there are not too many ("Ansicht aktuaisieren..." Snacks displayed)
  if (
    value.showProcess &&
    !ProcessIsRunning("SYSTableRebuild", value.defId)
    // removed because eg. diahem in verpacken with not so many rows you would like to have feedback when sort/filter clicked
    // &&
    // Object.keys(data).length >= 200 &&
    // (!def.options.initial_paging.pageSize ||
    //   def.options.initial_paging.pageSize >=
    //     200) /*&& dt - lastRebuildIndicator > 2000*/
  ) {
    /*lastRebuildIndicator = dt*/
    appDefProcess = { snack: { type: "BusyIndicator" }, instance: value.defId }
  } else {
    appDefProcess = { instance: value.defId }
  }

  ProcessStart("SYSTableRebuild", appDefProcess)

  if (value.forcedFilters?.staticFilter) {
    value.forcedFilters.staticFilter = JSON.parse(
      JSON.stringify(value.forcedFilters.staticFilter)
    )
    def.uiState.filter.filter.static = value.forcedFilters.staticFilter
  }

  //delete lookup list cache
  _cachedFieldLists.forEach((_value, key) => {
    if (key.startsWith(`@@table:${def.id}`)) {
      _cachedFieldLists.set(key, undefined)
    }
  })

  //now the eschema should be ready. So scheck if there are column types missing nd assign them

  let schema = value.data.schema
  if (schema) {
    Object.keys(def.columns)
      .filter((f) => def.columns[f].type === undefined)
      .forEach((c) => {
        if (schema?.[c]) {
          def.columns[c].type = schema[c].type
        } else {
          def.columns[c].type = "text"
        }
      })
  }

  // This looks like a good place to use the persisted filter/sort settings
  // be it those from the indexed browser db or those saved as favorites

  if (value.enableFilterSortPersist) {
    if (!def.options.filterSortSettings.enablePersist) {
      //enable persist
      def.options.filterSortSettings.enablePersist = true
      def.uiState._lastFilterSortDifferentiator = "@@OvlInitValue@@Ovl"
    }
  } else if (value.enableFilterSortPersist === false) {
    if (def.options.filterSortSettings.enablePersist) {
      //disable persist
      def.options.filterSortSettings.enablePersist = false
    }
  }

  let forceFilterChanged = false

  if (value.forcedFilters && "filters" in value.forcedFilters) {
    def.uiState.filter._forced = value.forcedFilters.filters
    def.uiState.filter._forced._originalPersistedState = {}
    let newFilterCompareString = JSON.stringify(
      def.uiState.filter._forced,
      sortedReplacer
    )
    if (
      newFilterCompareString !== def.uiState.filter._forced._filtersCheckString
    ) {
      forceFilterChanged = true
      def.uiState.filter._forced._filtersCheckString = newFilterCompareString
    }
  }

  let forcedFilterState = def.uiState.filter._forced

  if (!def.uiState.filter.filter.forcedFilterKeys) {
    let filterSortStoreDifferentiator = _GetFilterSortDifferentiator(def.id)
    if (
      def.uiState._lastFilterSortDifferentiator !==
        filterSortStoreDifferentiator ||
      forceFilterChanged
    ) {
      def.uiState._lastFilterSortDifferentiator = filterSortStoreDifferentiator
      let filterSortPermissions = _GetFilterSortPermission(def.id)
      let filterSortSetFromIndexedDB = false

      // Object.keys(staticFilter)
      //   .map((m) => staticFilter[m].toString())
      //   .join(";")

      let filterSortPerStaticFilter
      if (def.options.filterSortSettings?.enablePersist) {
        filterSortPerStaticFilter = await filterSortStore.get(
          `${state.ovl.user.userCode.toString()}_${
            def.id
          }_${filterSortStoreDifferentiator}`
        )
      }
      if (!filterSortPerStaticFilter) {
        await _ResetFilters(def)
        await _ResetSort(def)
      }
      if (filterSortPerStaticFilter !== undefined) {
        if (filterSortPerStaticFilter.version === 1) {
          // upgrade to new version
          // i know we loose saved columnfilters here. but the saved format from list was not the rawValue...now it is
          Object.keys(filterSortPerStaticFilter.filterColumns).forEach((k) => {
            if (
              filterSortPerStaticFilter.filterColumns[k]?.columnFilter?.list
            ) {
              if (def.columns[k]?.list) {
                // we just need to reset those from lists
                filterSortPerStaticFilter.filterColumns[k].columnFilter.list =
                  []
              }
            }
          })
          filterSortPerStaticFilter.version = 2
        }

        // We need to call the TableColumnFilter API here (Becaus it calls TableFn which could cancel or do other stuff...). But only if Filter changed
        if (!def.uiState._resetStrategyForPersistFilterSort?.Filter) {
          await Promise.all(
            Object.keys(filterSortPerStaticFilter.filterColumns).map(
              async (f) => {
                if (def.uiState.filter.columns[f]) {
                  if (def.uiState.filter.columns[f].rangeFilter) {
                    def.uiState.filter.columns[f].rangeFilter =
                      filterSortPerStaticFilter.filterColumns[f].rangeFilter
                  }
                  if (def.uiState.filter.columns[f].columnFilter) {
                    let currentFilter = JSON.stringify(
                      def.uiState.filter.columns[f]
                    )
                    let newFilter = JSON.stringify(
                      filterSortPerStaticFilter.filterColumns[f]
                    )
                    if (
                      currentFilter !== newFilter &&
                      filterSortPerStaticFilter.filterColumns[f].columnFilter
                    ) {
                      if (
                        !(await TableColumnFilter(
                          def.id,
                          f,
                          filterSortPerStaticFilter.filterColumns[f]
                            .columnFilter.list,
                          {
                            exclusive:
                              filterSortPerStaticFilter.filterColumns[f]
                                .columnFilter.exclusive,
                            _innerEvent: true,
                          }
                        ))
                      ) {
                        return
                      }
                    }
                  }
                }
              }
            )
          )
          await Promise.all(
            Object.keys(filterSortPerStaticFilter.filterCustom).map(
              async (f) => {
                if (
                  !(await TableCustomFilter(
                    def.id,
                    f,
                    filterSortPerStaticFilter.filterCustom[f],
                    { _innerEvent: true }
                  ))
                ) {
                  return
                }
              }
            )
          )
          if (filterSortPerStaticFilter.filterAttributes) {
            let filterAttributes = filterSortPerStaticFilter.filterAttributes
            let filterAttributesInitial = def.options.initial_rowAttributes
            await Promise.all(
              Object.keys(filterAttributesInitial).map(async (defKey) =>
                Object.keys(filterAttributesInitial[defKey].attributes)
                  .concat(
                    Object.keys(
                      filterAttributes[defKey]?.attributes
                        ? filterAttributes[defKey].attributes
                        : {}
                    )
                  )

                  .map(async (attributeKey) => {
                    let val =
                      !!filterAttributes[defKey].attributes[attributeKey]
                    if (
                      !(await TableAttributeFilter(
                        def.id,
                        defKey,
                        attributeKey,
                        val,
                        {
                          _innerEvent: true,
                        }
                      ))
                    ) {
                      return
                    }
                  })
              )
            )
          }

          def.uiState.filter.filter.value =
            filterSortPerStaticFilter.filterTable.value
          // selection filter doesn't nake sense to store. because this would mean we should store the selected keys as well            def.uiState.filter.filter.showSelected =
          //filterSortPerStaticFilter.filterTable.showSelected
          filterSortSetFromIndexedDB = true
        }
        // def.uiState.filter.filter.showSelected =
        //   filterSortPerStaticFilter.filterTable.showSelected

        if (!def.uiState._resetStrategyForPersistFilterSort?.Sort) {
          if (def.columns[filterSortPerStaticFilter.sort[0].field]) {
            def.uiState.sort.sort = filterSortPerStaticFilter.sort[0]
          }

          if (
            !filterSortPerStaticFilter.sortCustomSelected ||
            def.uiState.sort._initial_sortCustomFlat?.[
              filterSortPerStaticFilter.sortCustomSelected
            ]
          ) {
            def.uiState.sort.sortCustom.selected =
              filterSortPerStaticFilter.sortCustomSelected
          }
          filterSortSetFromIndexedDB = true
        }
        if (
          filterSortPermissions.found /*&&
          !_FilterChangedComparedToDefault(def)*/
        ) {
          def.uiState.currentSelectedFilterSort =
            filterSortPerStaticFilter.selected
          def.uiState.currentSelectedFilterSortDesc =
            filterSortPerStaticFilter.selectedDesc
          def.uiState.currentSelectedFilterSortValue =
            filterSortPerStaticFilter.selectedValue
        } else {
          def.uiState.currentSelectedFilterSort = ""
          def.uiState.currentSelectedFilterSortDesc = ""
          def.uiState.currentSelectedFilterSortValue = ""
        }
      }
      def.uiState._resetStrategyForPersistFilterSort = undefined
    }
  }

  if (forcedFilterState) {
    // take car of forced custom filters
    // eg. usecase bar activities. if users selects "open activities" as the datasource (serverfilter) then it doesnt make sense to use a persisted custom filter which filters by closed activities
    let custom = {}
    let columnFiltersOrig = {}

    const { activeKeySet, inactiveKeySet } =
      _GetActiveInactiveForcedFilterCustom(def)

    const forcedColumnFiltersKeysSet = _GetForcedColumnFiltersKeys(def)

    const keySet = new Set([...activeKeySet, ...inactiveKeySet])
    if (!def.uiState.filter._forced._originalPersistedState.custom) {
      for (const k of keySet) {
        if (def.uiState.filter.filterCustom[k]) {
          custom[k] = JSON.parse(
            JSON.stringify(def.uiState.filter.filterCustom[k])
          )
        }
      }
      def.uiState.filter._forced._originalPersistedState.custom = custom
    }

    if (!def.uiState.filter._forced._originalPersistedState.columnFilters) {
      for (const k of forcedColumnFiltersKeysSet) {
        if (def.uiState.filter.columns[k]) {
          columnFiltersOrig[k] = JSON.parse(
            JSON.stringify(def.uiState.filter.columns[k])
          )
        }
      }
      def.uiState.filter._forced._originalPersistedState.columnFilters =
        columnFiltersOrig
    }

    for (const k of inactiveKeySet) {
      if (def.uiState.filter.filterCustom[k].active) {
        await TableCustomFilter(def.id, k, false, { _innerEvent: true })
      }
    }
    for (const k of activeKeySet) {
      if (!def.uiState.filter.filterCustom[k].active) {
        await TableCustomFilter(def.id, k, true, { _innerEvent: true })
      }
    }

    for (const k of forcedColumnFiltersKeysSet) {
      if (def.uiState.filter.columns[k]) {
        let forced = forcedFilterState.forcedColumnFilters[k]
        if (forced.columnFilter) {
          if (forced.columnFilter.type === "none") {
            await TableColumnFilter(def.id, k, undefined, { _innerEvent: true })
          } else {
            await TableColumnFilter(def.id, k, forced.columnFilter.list, {
              exclusive: forced.columnFilter.exclusive,
              _innerEvent: true,
            })
          }
        }
        if (forced.rangeFilter) {
          def.uiState.filter.columns[k].rangeFilter = JSON.parse(
            JSON.stringify(forced.rangeFilter)
          )
        }
      }
    }
  }

  await new Promise((resolve) =>
    setTimeout(async () => {
      // init aggregates
      try {
        let aggregateHookFn = {}
        def.uiState.tableGroupResults = {}
        let tableGroupResults = def.uiState.tableGroupResults
        let expressionHookFn = {}

        let tableGroupCodes = def.options.tableGroupAggregates.groups

        let isValidForCurrentSort = true
        let arrLength =
          def.options.tableGroupAggregates.onlyApplyWhenColumnSortStartsWith
            .length
        if (arrLength > 0 && def.uiState.sort.sort.field) {
          // i'm just doing it like that to be prepared for user multicolumn search
          let fieldArr: any = def.uiState.sort.sort.field
          // future proofing. can be removed after making sort an array anyway
          if (!Array.isArray(fieldArr)) {
            fieldArr = [def.uiState.sort.sort.field]
          }
          if (fieldArr.length > arrLength) {
            fieldArr.splice(arrLength)
          }
          if (
            JSON.stringify(fieldArr) !==
            JSON.stringify(
              def.options.tableGroupAggregates.onlyApplyWhenColumnSortStartsWith
            )
          ) {
            isValidForCurrentSort = false
          }
        }
        arrLength =
          def.options.tableGroupAggregates.onlyApplyWhenCustomSort.length
        if (
          arrLength > 0 &&
          def.options.tableGroupAggregates.onlyApplyWhenCustomSort.indexOf(
            def.uiState.sort.sortCustom.selected
          ) < 0
        ) {
          isValidForCurrentSort = false
        }

        if (fn && !def.options.tableGroupAggregates.disabled) {
          let columnsToSet =
            def.uiState.columnsRenderingState.visibleInTable.reduce(
              (val, columnKey) => {
                val[columnKey] = {
                  value: undefined,
                  cssClass: undefined,
                }
                return val
              },
              {}
            )
          // let template = {
          //   cssClass: "",
          //   type: undefined,
          //   columnsToSet,
          //   oneColumnFullWidthToSet: {
          //     value: undefined,
          //     cssClass: undefined,
          //   },
          //   customToSet: undefined,
          // }
          def.uiState.groupHeaderFooterResultToSet = columnsToSet

          def.options.tableGroupAggregates.aggregates.forEach(
            (aggregateKey) => {
              let aggregateCode = aggregateKey.aggregateCode
              if (aggregateCode !== "@@SYSTotal") {
                let fnName = HookTableGroupCalcValue.replace(
                  "{aggregateKey}",
                  aggregateCode
                )
                if (fn[fnName]) {
                  aggregateHookFn[aggregateCode] = fn[fnName]
                } else {
                  //aggregateInitResult Hook is mandatory
                  throw new Error(
                    `SYS TableGroupAggregate: Hook ${fnName} is missing!`
                  )
                }
              }
              tableGroupResults[aggregateCode] = {}
            }
          )

          if (!isValidForCurrentSort) {
            tableGroupCodes = [{ groupCode: "@@SYSTotal" }]
          }

          tableGroupCodes.forEach((groupKey) => {
            let groupCode = groupKey.groupCode
            if (groupCode !== "@@SYSTotal") {
              let fnName = HookTableGroupValue.replace("{groupKey}", groupCode)
              if (fn[fnName]) {
                expressionHookFn[groupCode] = fn[fnName]
              } else {
                //expression Hook is mandatory
                throw new Error(
                  `SYS TableGroupExpression: Hook ${fnName} is missing!`
                )
              }
            }
            /*            tableGroupCalc[groupCode] = undefined*/
          })
        }
        let tableGroupHeaderBreaks = def.uiState.tableGroupHeaderBreaks
        let tableGroupFooterBreaks = def.uiState.tableGroupFooterBreaks

        let tableGroupCalc = {}

        let selectedFilterSort = def.uiState.currentSelectedFilterSort
        let differentiator = _GetFilterSortDifferentiator(def.id)
        def.uiState.currentSelectedFilterSortStore[differentiator] =
          def.uiState.currentSelectedFilterSort
        if (
          !def.uiState.filter.filter.forcedFilterKeys &&
          def.options.filterSortSettings?.enablePersist
        ) {
          // persist curent filter/sort to indexed db

          let filterCustomToPersist = def.uiState.filter.filterCustom

          let originalPersistedState =
            def.uiState.filter._forced?._originalPersistedState?.custom
          let originalPersistedStateColFilters =
            def.uiState.filter._forced?._originalPersistedState?.columnFilters

          let filterCustomFlat = def.uiState.filter._initial_filterCustomFlat
          await filterSortStore.set(
            `${state.ovl.user.userCode.toString()}_${def.id}_${differentiator}`,
            {
              version: 2,
              ts: new Date().toISOString(),
              filterColumns: Object.keys(def.uiState.filter.columns).reduce(
                (val, k) => {
                  if (originalPersistedStateColFilters?.[k]) {
                    val[k] = originalPersistedStateColFilters[k]
                  } else {
                    val[k] = def.uiState.filter.columns[k]
                  }
                  return val
                },
                {}
              ),
              filterTable: {
                // selection filter doesn't nake sense to store. because this would mean we should store the selected keys as well
                //showSelected: def.uiState.filter.filter.showSelected,
                value: def.uiState.filter.filter.value,
              },
              filterCustom: Object.keys(filterCustomToPersist).reduce(
                (val, k) => {
                  if (originalPersistedState?.[k]) {
                    val[k] = originalPersistedState[k].active
                    if (val[k] === true && filterCustomFlat[k]._isOption) {
                      let grp = filterCustomFlat[k]._groupKey
                      // loop the group set others to false
                      Object.keys(filterCustomFlat)
                        .filter(
                          (f) =>
                            f !== k && filterCustomFlat[f]._groupKey === grp
                        )
                        .forEach((f) => {
                          val[f] = false
                        })
                    }
                  } else {
                    val[k] = filterCustomToPersist[k].active
                    if (val[k] === true && filterCustomFlat[k]._isOption) {
                      let grp = filterCustomFlat[k]._groupKey
                      // loop the group set others to false
                      Object.keys(filterCustomFlat)
                        .filter(
                          (f) =>
                            f !== k && filterCustomFlat[f]._groupKey === grp
                        )
                        .forEach((f) => {
                          val[f] = false
                        })
                    }
                  }
                  return val
                },
                {}
              ),
              filterAttributes: def.uiState.filter.filterAttributes,
              sort: [def.uiState.sort.sort],
              sortCustomSelected: def.uiState.sort.sortCustom.selected,
              selected: selectedFilterSort,
              selectedDesc: def.uiState.currentSelectedFilterSortDesc,
              selectedValue: def.uiState.currentSelectedFilterSortValue,
            }
          )
        }

        let restable
        let rebuildCache = new Map<string, any>()
        // 1. Update the UI State based on explicit parameters
        if (value.forcedFilters !== undefined) {
          if (value.forcedFilters.forceFilterKeys) {
            if (value.forcedFilters.forceFilterContextTitle) {
              def.uiState.filter.filter.forcedFilterContextTitle =
                value.forcedFilters.forceFilterContextTitle
            }
            def.uiState.filter.filter.forcedFilterKeys = GetTableKeys(
              def,
              value.data,
              value.forcedFilters.forceFilterKeys
            )
          } else {
            // Explicitly dropped
            if (def.uiState.filter.filter.forcedFilterKeys) {
              def.uiState.filter.filter.forcedFilterKeys = undefined
              def.uiState.filter.filter.forcedFilterContextTitle = undefined
              if (def.uiState.filter._forced?._originalPersistedState?.custom) {
                def.uiState.filter._forced._originalPersistedState.custom =
                  undefined
              }
            }
          }
        }

        // 2. Build the hitlist based on the current UI State
        if (def.uiState.filter.filter.forcedFilterKeys) {
          def.uiState.currentSelectedFilterSort = ""
          def.uiState.currentSelectedFilterSortDesc = ""
          def.uiState.currentSelectedFilterSortValue = ""
        }
        restable = _TableFilterFn({ def, data: value.data }, undefined)

        restable = TableSortFn(def, restable, data, rebuildCache)
        let selectedRow = def.uiState.selectedRow
        // let editRow = def.uiState.editRow
        //let viewRow = def.uiState.viewRow
        let resTableLength = restable.length
        let kBefore = ""
        let staticFilter = def.uiState.filter.filter.static
        let staticFilterKeys = Object.keys(staticFilter)
        restable.forEach((k, i) => {
          let isLastRow = i === resTableLength - 1
          if (!selectedRow[k]) {
            selectedRow[k] = {
              selected: false,
              showNav: false,
              count: 0,
            }
          }
          if (
            def.id !== "SYSTableSettings_ColumnFilter" &&
            !def.options.tableGroupAggregates.disabled
          ) {
            if (!tableGroupHeaderBreaks[k]) {
              tableGroupHeaderBreaks[k] = {
                groupAccessStrings: [],
                groups: {},

                isBreak: false,
                isFirstRow: i === 0,
                isLastRow,
              }
            } else {
              tableGroupHeaderBreaks[k].groupAccessStrings = []
              tableGroupHeaderBreaks[k].groups = {}
              tableGroupHeaderBreaks[k].isBreak = false
              tableGroupHeaderBreaks[k].isFirstRow = i === 0
              tableGroupHeaderBreaks[k].isLastRow = isLastRow
            }

            if (!tableGroupFooterBreaks[k]) {
              tableGroupFooterBreaks[k] = {
                groupAccessStrings: [],
                groups: {},

                isBreak: isLastRow,
                isFirstRow: i === 0,
                isLastRow,
              }
            } else {
              tableGroupFooterBreaks[k].groupAccessStrings = []
              tableGroupFooterBreaks[k].groups = {}
              tableGroupFooterBreaks[k].isBreak = isLastRow
              tableGroupFooterBreaks[k].isFirstRow = i === 0
              tableGroupFooterBreaks[k].isLastRow = isLastRow
            }

            // let fKey = kBefore
            // if (isLastRow) {
            //   fKey = k
            // }
            tableGroupCodes.forEach((groupKey) => {
              let groupCode = groupKey.groupCode
              let groupValue
              if (groupCode !== "@@SYSTotal") {
                groupValue = expressionHookFn[groupCode]({
                  def,
                  data: value.data,
                  row: data[k],
                })

                tableGroupHeaderBreaks[k].groupAccessStrings.push(groupValue)
                tableGroupFooterBreaks[k].groupAccessStrings.push(groupValue)

                // if (
                //   groupValue == "20221" &&
                //   tableGroupCalc?.["Year"] == 2022
                // ) {
                //   debugger
                // }
              } else {
                groupValue = "1"
              }
              let groupValChanged = groupValue !== tableGroupCalc[groupCode]

              if (groupValChanged || isLastRow) {
                if (kBefore && groupValChanged) {
                  if (!tableGroupFooterBreaks[kBefore].groups[groupCode]) {
                    tableGroupFooterBreaks[kBefore].groups[groupCode] = {
                      groupValue: undefined,
                    }
                  }
                  tableGroupFooterBreaks[kBefore].groups[groupCode].groupValue =
                    tableGroupCalc[groupCode]
                  tableGroupFooterBreaks[kBefore].isBreak = true
                }
                if (isLastRow) {
                  if (!tableGroupFooterBreaks[k].groups[groupCode]) {
                    tableGroupFooterBreaks[k].groups[groupCode] = {
                      groupValue: undefined,
                    }
                  }

                  tableGroupFooterBreaks[k].groups[groupCode].groupValue =
                    groupValue
                }

                if (groupValChanged) {
                  if (!tableGroupHeaderBreaks[k].groups[groupCode]) {
                    tableGroupHeaderBreaks[k].groups[groupCode] = {
                      groupValue: undefined,
                    }
                  }
                  tableGroupHeaderBreaks[k].groups[groupCode].groupValue =
                    groupValue
                  tableGroupHeaderBreaks[k].isBreak = true
                }
              }
              tableGroupCalc[groupCode] = groupValue
            })
          }
          if (fn && !def.options.tableGroupAggregates.disabled) {
            //build up aggregates
            //its important here to follow the def structure

            Object.keys(tableGroupResults).forEach((aggregateKey) => {
              let groupCodes = ""
              let groupValues = ""
              tableGroupCodes.forEach((groupKey, z) => {
                let groupCode = groupKey.groupCode
                if (!tableGroupResults[aggregateKey][groupCode]) {
                  tableGroupResults[aggregateKey][groupCode] = {}
                }
                let groupValue = tableGroupCalc[groupCode]
                groupCodes = `${groupCodes}${groupCode}`
                groupValues = `${groupValues}${groupValue}`
                let currentResult =
                  tableGroupResults[aggregateKey][groupCode][groupValue]
                if (!currentResult) {
                  // its a new result so get init value
                  // important to get a new instance hence json.parse...
                  currentResult = _TableGetGroupInitAggregateResult()
                }
                let currentValue
                if (aggregateKey !== "@@SYSTotal") {
                  currentValue = aggregateHookFn[aggregateKey]({
                    def,
                    data: value.data,
                    row: data[k],
                  })
                } else {
                  currentValue = 1
                }
                let newResult = _TableGroupCalcAggregate(
                  currentResult,
                  currentValue,
                  k
                )
                tableGroupResults[aggregateKey][groupCode][groupValue] =
                  newResult
                if (z > 0) {
                  if (!tableGroupResults[aggregateKey][groupCodes]) {
                    tableGroupResults[aggregateKey][groupCodes] = {}
                  }
                  let currentMultiResult =
                    tableGroupResults[aggregateKey][groupCodes][groupValues]
                  if (!currentMultiResult) {
                    currentMultiResult = _TableGetGroupInitAggregateResult()
                  }
                  let newMultiResult = _TableGroupCalcAggregate(
                    currentMultiResult,
                    currentValue,
                    k
                  )
                  tableGroupResults[aggregateKey][groupCodes][groupValues] =
                    newMultiResult
                }
              })
            })
          }
          kBefore = k
        })
        def.uiState.rowsCount = restable.length
        if (def.options.rendering.tableControls.page.visible) {
          let paging = def.uiState.paging
          let nrOfPages = Math.ceil(restable.length / paging.pageSize)
          if (paging.page > nrOfPages - 1) {
            paging.page = nrOfPages - 1
            if (paging.page < 0) {
              paging.page = 0
            }
          }
        }

        def.uiState.dataFilteredAndSorted = restable
        def.uiState.lastRowKey = undefined
        if (restable.length > 0) {
          def.uiState.lastRowKey = restable[restable.length - 1]
        }
        def.uiState.tableFilterClass = ""
        if (def.uiState.filter.filter.forcedFilterKeys) {
          def.uiState.tableFilterClass = "__tbfilterforced"
        } else if (def.uiState.filter.filter.value) {
          def.uiState.tableFilterClass = "__tbfilter"
        }
        await _TableSetColumnVisibility(def, actions, state, false)
        if (
          def.id !== "SYSTableSettings_FilterSort" &&
          def.id !== "SYSTableSettings_ColumnFilter"
        ) {
          let selectionClipping = value.selectionClipping
          if (!selectionClipping) {
            selectionClipping = def.options.filterSortSettings.selectionClipping
          }
          if (
            selectionClipping === "Remove" ||
            selectionClipping === "Prompt"
          ) {
            if (
              selectionClipping !== "Prompt" ||
              (await DialogOkCancel(T("SYSSelectionClippingPrompt"), {
                instance: `${def.id}_SelectionClipping`,
              })) === 1
            ) {
              let tb = TableGet(def.id)
              let selectedKeys = tb.getKeys({ byKeys: "Selected" })
              let visibleKeys = tb.getKeys({ byKeys: "Visible" })
              selectedKeys
                .filter((f) => !visibleKeys.includes(f))
                .forEach((k) => {
                  def.uiState.selectedRow[k].selected = false
                  def.uiState.selectedRow[k].showNav = false
                })
            }
          }
        }
        let afterRebuildFn = fn?.[HookTableRowsAfterRebuild]
        if (afterRebuildFn) {
          afterRebuildFn(<HookTableRowsAfterRebuild_Type>{
            def,
            rows: data,
            rowKeys: def.uiState.dataFilteredAndSorted,
          })
        }

        setTableNeedsRefresh(def, false)
        def.uiState.rebuild.addedKeys = {}
        def.uiState.rebuild.deletedKeys = {}
        def.uiState.rebuild.updatedKeys = {}
        def.uiState.rebuild.changed = {}
      } finally {
        ProcessEnd("SYSTableRebuild", value.defId)
      }
      resolve(true)
    }, 50)
  )
  ProcessEnd("SYSTableRefresh")
}

export const _TableOfflineRetrySaveRow: SYSAction<
  {
    data: SYSTableData
    defId: SYSTableDefIds
    rowToSave: {}
    key: string
    isAdd: boolean
  },
  Promise<_TableEditSaveResultsType>
> = async (value, { global }) => {
  let state = global.getState()
  let actions = global.getActions()
  let data = value.data
  let def = data.tableDef[value.defId]
  let rowToSave = value.rowToSave
  let key = value.key
  if (!data.data[key]) {
    // some other process already took care of it. so its ok
    return { results: [{ type: "success", key }], changedFields: rowToSave }
  }
  ;(data.data[key].OvlSysState as OvlSysColumn).rowState.state = value.isAdd
    ? "Add"
    : "Update"
  return await _TableEditSaveRowsHelper(
    [key],
    def,
    data,
    null,
    state,
    actions,
    undefined,
    rowToSave,
    true,
    true
  )
}

export const _TableDirectSaveRow: SYSAction<
  {
    data: SYSTableData
    defId: SYSTableDefIds
    rowToSave: {}
    suppressFeedbackSnack?: boolean
    noSnack?: boolean
    suppressBusySnack?: boolean
    process?: _ProcessReturnType
    files?: FileUploadContainer[]
    multi?: { isFirst: boolean; isLast: boolean }
    ignoreNeedsRefresh?: boolean
    originalIdIfUpdate?: any
  },
  Promise<{ newId: any; rowKey: string }>
> = async (value, { global }) => {
  let state = global.getState()
  let actions = global.getActions()
  let data = value.data
  let def = data.tableDef[value.defId]
  // clone it -> important!!! usecase tablerefresh during update/add (timeportal -> reduce interval to 2 sec and update effort)
  let rowToSave = JSON.parse(JSON.stringify(value.rowToSave))

  let rowId
  if (value.originalIdIfUpdate === undefined) {
    rowId = rowToSave[def.database.dataIdField]
  } else {
    rowId = value.originalIdIfUpdate
  }

  let key

  if (!def.initialised) {
    await initTableState(def, data, value.defId)
  }

  // cases for directsave row
  // 1. we have a row with an undefined id -> add
  // 2. we have a row with an id but its not in the index -> add
  // 3. we have a row ith an id and a index -> update
  let isAdd = false
  if (rowId === undefined || !data.index[rowId]) {
    // case 1 and 2
    isAdd = true
    key = SYSSeqId()
    if (rowId === undefined) {
      // also if there is no id then let the backend generate one
      rowId = key
    }
    rowToSave[def.database.dataIdField] = rowId
    // attention looks like it could be refactored. but let it be. there needs to be the init like that

    if (!data.data[key]?.OvlSysState) {
      data.data[key] = { OvlSysState: _GetOvlSysColDefault() }
    }
    data.data[key].OvlSysState.rowState.originalId = rowId
    data.data[key].OvlSysState.rowState.state = "Add"
  } else {
    // case 3.
    key = data.index[rowId]
    data.data[key].OvlSysState.rowState.state = "Update"
  }

  if (isAdd) {
    data.index[rowId] = key
    if (!data.data[key]) {
      data.data[key] = { OvlSysState: _GetOvlSysColDefault() }
    }
    Object.keys(rowToSave).forEach((f) => {
      data.data[key][f] = rowToSave[f]
    })

    // any default values from column?
    Object.keys(def.columns).forEach((k) => {
      let column = def.columns[k]
      if (column.schema?.defaultValue !== undefined) {
        data.data[key][k] = column.schema.defaultValue
      }
    })
    // as well staticfilter will be set already
    Object.keys(def.uiState.filter.filter.static).forEach((k) => {
      data.data[key][k] = def.uiState.filter.filter.static[k]
    })

    // also if schema check default values from there if not already set
    let schema = value.data.schema
    if (schema) {
      Object.keys(schema).forEach((f) => {
        if (
          f !== def.database.dataIdField &&
          data.data[key][f] === undefined &&
          schema[f]?.defaultValue !== undefined &&
          schema[f]?.defaultValue !== null
        ) {
          data.data[key][f] = schema[f].defaultValue
        }
      })
    }
  } else {
    //we never need the id in the data unless its an key update
    if (value.originalIdIfUpdate === undefined) {
      delete rowToSave[def.database.dataIdField]
    }
    if (
      def.database.dbInsertMode.indexOf("UDT") > -1 &&
      def.database.dbInsertMode.indexOf("Both") > -1
    ) {
      delete rowToSave["Name"]
    }
  }
  let suppressFeedbackSnack =
    value.suppressFeedbackSnack ?? value.noSnack ?? false
  let res = await _TableEditSaveRowsHelper(
    [key],
    def,
    data,
    null,
    state,
    actions,
    value.multi,
    rowToSave,
    suppressFeedbackSnack,
    undefined,
    value.files,
    value.ignoreNeedsRefresh,
    value.suppressBusySnack,
    value.process
  )
  let newId = undefined
  let result = res.results[0]
  if (result && result.type === "success") {
    newId = data.data[result.key][def.database.dataIdField]
    if (isAdd) {
      def.uiState.selectedRow[key] = {
        selected: false,
        showNav: false,
        count: 0,
      }
      def.uiState.tableGroupHeaderBreaks[key] = {
        groups: {},
        isBreak: false,
        isFirstRow: false,
        isLastRow: false,
      }
      def.uiState.tableGroupFooterBreaks[key] = {
        groups: {},
        isBreak: false,
        isFirstRow: false,
        isLastRow: false,
      }
    }
    //dont use formState.TableRowMode...That gets changed in EditSaveRowHelper for currently unknown reason
    _AddRowToDisplayedArray(def, key)
    return { newId, rowKey: key }
  }
  // // it was not a success
  // // if it was an add we should remove the row
  // if (isAdd) {
  //   TableRemoveRowFromData(def.id, key)
  // }

  if (result && result.type === "beforesavehook_cancel") {
    // if an add gets canceled row needs to be removed
    TableRemoveRowFromData(def.id, key)
  } else {
    throw new _TableRowError(data.data[key].OvlSysState, key, def.id)
  }
}

export class _TableRowError extends Error {
  constructor(
    ovlSysState: OvlSysColumn,
    rowKey: string,
    tableDefId: SYSTableDefIds
  ) {
    // get out err message safely
    let feedback =
      ovlSysState?.fnFeedback?.[Object.keys(ovlSysState?.fnFeedback || {})[0]]
    let message = feedback?.text?.toString() || "Table save error"
    super(message)
    this.ovlSysState = ovlSysState
    this.code = feedback?.code || ""
    this.rowKey = rowKey
    this.tableDefId = tableDefId
    this.snacked = feedback?.snacked === true
    this.suppressFeedbackSnack = feedback?.suppressFeedbackSnack === true
  }
  code: string
  rowKey: string
  tableDefId: SYSTableDefIds
  ovlSysState: OvlSysColumn
  snacked: boolean
  suppressFeedbackSnack: boolean
  handled = (removeRow?: boolean) => {
    if (removeRow) {
      TableRemoveRowFromData(this.tableDefId, this.rowKey)
    } else {
      this.ovlSysState.rowState.state = "Ok"
    }
  }
  getRowState = (): RowState => this.ovlSysState.rowState.state
}

export const _TableEditSaveRow: SYSAction<
  {
    key: string
    def: SYSTableDef
    data: SYSTableData
    formState: SYSFormState
    suppressFeedbackSnack?: boolean
    suppressBusySnack?: boolean
  },
  Promise<_TableEditSaveResultsType>
> = async (value, { global }) => {
  let state = global.getState()
  let actions = global.getActions()
  return await _TableEditSaveRowsHelper(
    [value.key],
    value.def,
    value.data,
    value.formState,
    state,
    actions,
    undefined,
    undefined,
    value.suppressFeedbackSnack === true,
    undefined,
    undefined,
    undefined,
    value.suppressBusySnack === true
  )
}

const EditSaveRowOfflineHelper = (
  def: SYSTableDef,
  data: SYSTableData,

  newData: any,
  isAdd: boolean,
  rowid: string,
  key: string
) => {
  let returnedKeys = new Map<string, ServerData_ChangedType>()
  let addedKeys = data.offline.addedKeys
  if (isAdd) {
    data.offlineSeq++
    addedKeys[key] = data.offlineSeq
  } else {
    // if its an update to an added key its already handled...
    if (!addedKeys[key]) {
      let updatedKeys = data.offline.updatedKeys
      if (!updatedKeys[key]) {
        data.offlineSeq++
        updatedKeys[key] = { columns: {}, timestamp: data.offlineSeq }
      }
      Object.keys(newData).forEach((k) => {
        updatedKeys[key].columns[k] = true
      })
    }
  }
}

export type FileUploadContainer = {
  files: any
  fieldKey: string
}

export type _TableEditSaveResultType = {
  type: "error" | "success" | "beforesavehook_cancel"

  //code?: string
  key?: string
}

export type _TableEditSaveResultsType = {
  results: _TableEditSaveResultType[]
  changedFields: { [key: string]: any }
}

export const _TableEditSaveRowsHelper = async (
  keys: string[],
  def: SYSTableDef,
  data: SYSTableData,
  formState: SYSFormState | null,
  state: SYSState,
  actions: SYSActions,
  multi?: { isFirst: boolean; isLast: boolean },
  rowToSave?: {},
  suppressFeedbackSnack?: boolean,
  isOfflineRetry?: boolean,
  files?: FileUploadContainer[],
  ignoreNeedsRefresh?: boolean,
  suppressBusySnack?: boolean,
  parentProcess?: _ProcessReturnType
): Promise<_TableEditSaveResultsType> => {
  let newId
  let processInstanceKey
  let newData
  let hasFormState = formState !== null
  let process: _ProcessReturnType = parentProcess
  let results: _TableEditSaveResultsType = { results: [], changedFields: {} }
  let isBatchProcessing = keys.length > 1
  let isMultiProcessing = !!multi
  // saves the first key from which form the batch was started
  let originatingBatchKey = keys[0]
  let hasAtLeastOneServerSaved = false

  try {
    let rows = data.data
    // this fn is capable of saving the same changes to a list of keys (=Batch Processing)
    // this fn could be called from TableAddRow for multiple rows in sequence (=Multi Processing)
    let resFiles: FileUploadContainer[]
    if (hasFormState) {
      // take care of file uploads
      let fields = formState.fields

      resFiles = Object.keys(fields)
        .filter((f) => fields[f].type === "asset" && fields[f]._state._files)
        .map((k) => {
          let field = fields[k]
          let files = field._state._files
          return {
            files,
            fieldKey: field.fieldKey,
          }
        })
      //)
    }
    if (files !== undefined) {
      if (resFiles === undefined) {
        resFiles = []
      }
      resFiles = resFiles.concat(files)
    }

    for (let kdx = 0; kdx < keys.length; kdx++) {
      let rowFnResultAdded = false
      let key = keys[kdx]
      let row = rows[key]
      let fn = actions.app.features[def.feature]
      let rowId = (<OvlSysColumn>data.data[key].OvlSysState).rowState.originalId
      let isAdd =
        (<OvlSysColumn>data.data[key].OvlSysState).rowState.state === "Add"
      let backendDecidedToMakeAnUpdateInsteadOfAdd = false
      let rowFnResult: TableRowFnProcessRawFeedback_Type
      try {
        if (hasFormState) {
          newData = Object.keys(formState.fields)
            .filter((k) => {
              let rowVal = row[k]
              let convertedVal = formState.fields[k].convertedValue
              // if its a json col the compare stringify vals
              if (data.clientConversion[k]?.jsonParse) {
                // we need a sortedreplacer because elsewise we cannot compare because the order of props is different
                rowVal = JSON.stringify(rowVal, sortedReplacer)
                convertedVal = JSON.stringify(convertedVal, sortedReplacer)
              }
              return (
                (FieldIsDirty(formState.fields[k]) &&
                  convertedVal !== rowVal &&
                  row.hasOwnProperty(k)) ||
                isAdd ||
                formState.fields[k]._state?.forceSave
              )
            })
            .reduce((val: {}, k, i) => {
              val[k] = formState.fields[k].convertedValue
              return val
            }, {})
        } else {
          newData = rowToSave
        }
        if (isAdd) {
          // if user defined some values in the FormDataAdd Hook which are not columns
          // or if there are default values either from schema or field.schema.defaultvalues
          // those get set in the _
          // make sure those also gets submitted
          Object.keys(data.data[key]).forEach((f) => {
            if (f !== def.database.dataIdField && newData[f] === undefined) {
              newData[f] = data.data[key][f]
            }
          })
          // // now if there are default values from schema use them as well and apply if not already filled
          // // imo always use schema if there regardless the useSchema setting
          // if (data.schema) {
          //   Object.keys(data.schema).forEach((f) => {
          //     if (
          //       f !== def.database.dataIdField &&
          //       newData[f] === undefined &&
          //       data.schema[f]?.defaultValue !== undefined &&
          //       data.schema[f]?.defaultValue !== null
          //     ) {
          //       newData[f] = data.schema[f].defaultValue
          //     }
          //   })
          // }
        }
        let filter = JSON.parse(
          JSON.stringify(def.uiState.filter.filter.static)
        )
        if (filter) {
          if (isAdd) {
            Object.keys(filter).map((m) => {
              // only overwrite filter values when not already a valid one defined (think usecase b&v attachments upload using tabledirectadd)
              if (newData[m] === undefined) {
                newData[m] = filter[m]
              }
            })
          }
        }
        let endpoint: SaveMode = "update"
        if (isAdd) {
          endpoint = "add"
        }
        let beforeSaveRowFnName = HookTableBeforeSave

        let resData
        let res: any = {}

        let needToSave = true
        if (
          (!newData ||
            (Object.keys(newData).length === 0 &&
              (!hasFormState || !FormIsDirty(formState)))) &&
          (!resFiles || resFiles.length === 0)
        ) {
          // there is nothing to update...
          needToSave = false
        }

        let savedLocally = false
        let saveLocallyMode

        let changedRow = row
        if (newData) {
          changedRow = Object.assign(JSON.parse(JSON.stringify(row)), newData)
        }
        let customData = undefined
        let processSnack
        if (process) {
          if (!process.tableFn) {
            process.tableFn = {
              fnId: process.process || "SYSSaveRow",
              tableDefId: def.id,
              fnName: `${T(
                def.title.dialogTitle.entityNameTranslationKey
              )}: ${T("SYSTableRowFnSave")}`,
              lockedTableKeys: {},
            }
          } else {
            if (!process.tableFn.lockedTableKeys) {
              process.tableFn.lockedTableKeys = {}
            }
            if (!process.tableFn.tableDefId) {
              process.tableFn.tableDefId = def.id
            }
          }
          keys.forEach((k) => {
            if (process.tableFn.lockedTableKeys) {
              process.tableFn.lockedTableKeys[k] = true
            }
          })
        }
        let actualSuppressBusy = suppressBusySnack ?? !!parentProcess
        if (!process) {
          if (
            !actualSuppressBusy &&
            !isOfflineRetry &&
            (Object.keys(newData).length > 0 ||
              resFiles.length > 0 ||
              FormIsDirty(formState))
          ) {
            processSnack = <SnackState>{
              type: "BusyIndicator",
              text: `${T(def.title.dialogTitle.entityNameTranslationKey)} ${T(
                "SYSTableRowFnSave"
              )}`,
            }
          }

          processInstanceKey = `${def.id}_OvlSep_SYSSaveRow_OvlSep_Multi`
          process = ProcessStart("SYSSaveRow", {
            lock: { formState },
            instance: processInstanceKey,
            snack: processSnack,
            tableFn: {
              fnId: "SYSSaveRow",
              rowKey: key,
              tableDefId: def.id,
              fnName: `${T(
                def.title.dialogTitle.entityNameTranslationKey
              )}: ${T("SYSTableRowFnSave")}`,
              lockedTableKeys: keys.reduce((val, k) => {
                val[k] = true
                return val
              }, {}),
            },
          })
        }

        if (fn?.hooks?.[beforeSaveRowFnName]) {
          let beforeSaveRes: HookTableBeforeSave_ReturnType = await fn.hooks[
            beforeSaveRowFnName
          ](<HookTableBeforeSave_Type>{
            key,
            mode: isAdd ? "add" : "update",
            tableDef: { def, data },
            changedFields: newData,
            changedRow,
            originalRow: row,
            filter,
            isOfflineRetry,
            formState,
            resFiles,
            hasChanges: needToSave,
          })
          if (beforeSaveRes) {
            rowFnResult = beforeSaveRes.rowFnResult
            if (rowFnResult) {
              if (!rowFnResult.id) {
                // little helper if user forgot to set the id on the hook
                rowFnResult.id = key
              }
              if (!rowFnResult.type) {
                // little helper if user forgot to set the type
                rowFnResult.type = "success"
              }
            }
            customData = beforeSaveRes.customPostData
          }

          if (beforeSaveRes?.resolve === "Cancel") {
            // this is a hard cancel
            // if its originating from a form the form will also be closed
            ;(<OvlSysColumn>data.data[key].OvlSysState).rowState.state = "Ok"
            results.results.push({ type: "beforesavehook_cancel", key })
            continue
          } else if (beforeSaveRes?.resolve === "Error") {
            results.results.push({
              type: "error",
              key,
            })
            if (!rowFnResult) {
              rowFnResult = { type: "error", id: key }
            }
            await process.setFromResult(rowFnResult)
            continue
          } else if (beforeSaveRes?.resolve === "Handled") {
            ;(<OvlSysColumn>(
              data.data[key].OvlSysState
            )).rowState.lastChangeBelongsToTableDefId = def.id
            ;(<OvlSysColumn>data.data[key].OvlSysState).rowState.state = "Ok"
            results.results.push({ type: "success", key })
            if (!rowFnResult) {
              rowFnResult = { type: "success", id: key }
            }
            await process.setFromResult(rowFnResult)
            continue
          } else if (beforeSaveRes?.resolve === "ForceSaveAndContinue") {
            needToSave = true
          } else if (beforeSaveRes?.resolve === "SaveLocally") {
            saveLocallyMode = beforeSaveRes.resolve
          }
        }

        if (!saveLocallyMode) {
          if (def.features.saveLocallyMode === "SaveLocally") {
            saveLocallyMode = def.features.saveLocallyMode
          }
        }
        let rowId2 = (<OvlSysColumn>data.data[key].OvlSysState).rowState
          .originalId

        let mergeRowHookParams: _MergeRowHookParamsType
        let mergeFn =
          actions.app.features[def.feature]?.hooks?.[
            HookTableServerBeforeMergeRow
          ]
        if (mergeFn) {
          mergeRowHookParams = { defId: def.id, fn: mergeFn, tableData: data }
        }

        let changed: ServerData_ChangedType = { columns: {}, isAdd }
        if (saveLocallyMode || !def.server.endpoint) {
          // save locally
          let destRow = data.data[key]
          changed = _DoServerDataConversionSyncAndBuildUpRebuildAndChangedInfo(
            key,
            data.clientConversion,
            newData,
            destRow,
            def.uiState.rebuild,
            isAdd,
            mergeRowHookParams,
            data.checkForOtherModification
          )
          // Object.keys(newData).forEach((k) => {
          //   destRow[k] = newData[k]
          // })
          rowId2 = destRow[def.database.dataIdField]
          if (!rowFnResult) {
            rowFnResult = { type: "success", id: key }
          }
          savedLocally = true
        }
        if (!savedLocally && needToSave === false) {
          if (formState && key === originatingBatchKey) {
            FormSetUnDirty(formState)
          }
          ;(<OvlSysColumn>data.data[key].OvlSysState).rowState.state = "Ok"
          ;(<OvlSysColumn>(
            data.data[key].OvlSysState
          )).rowState.lastChangeBelongsToTableDefId = def.id
          //await process.setFromResult({ type: "success", id: key })
          //results.results.push({ type: "success", key })
          continue
        }
        let destRow
        if (!savedLocally) {
          hasAtLeastOneServerSaved = true
          //let offlineHandled = false
          if (
            Object.keys(newData).length > 0 ||
            resFiles.length > 0 ||
            FormIsDirty(formState)
          ) {
            if (
              SYSConfig.offline.enabled &&
              state.ovl.app.offline.api &&
              (data.offline.updatedKeys[key] || data.offline.addedKeys[key])
            ) {
              // its an update on a offline row so just ignore the server part
              // the offline handler will take care on adding the row with all the updates
              let destRow = data.data[key]
              //rows[newId] = newData
              Object.keys(newData).forEach((k) => {
                destRow[k] = newData[k]
              })
              // new 17.07.2024
              // offline stuff will be handled in custom polling
              // so in this case just update the offline state so it can be handled lateron from custom  polling
              ;(<OvlSysColumn>(
                data.data[key].OvlSysState
              )).rowState.lastChangeBelongsToTableDefId = def.id
              data.data[key].OvlSysState.rowState.state = "Ok"
              results.results.push({ type: "success", key })
              await process.setFromResult({
                type: "information",
                id: key,
                text: "queued for offline",
              })
              continue
            }

            let dataFormatCheck = false
            let fixedData = newData
            if (
              /*!isAdd ||*/
              def.server.endpoint &&
              isAdd
            ) {
              fixedData = JSON.parse(JSON.stringify(newData))
              if (def.database.dbInsertMode.indexOf("Manual") < 0) {
                delete fixedData[def.database.dataIdField]
              }
              delete fixedData.OvlSysState
            }

            // lil hack for udts, the name is redundant if auto given
            if (
              def.database.dbInsertMode.indexOf("UDT") > -1 &&
              def.database.dbInsertMode.indexOf("Both") > -1
            ) {
              delete fixedData["Name"]
            }

            let screenCurrentState = ScreenCurrentState()
            let uiContext: UIContextType = {
              feature: <string>def.feature,
              tableDefId: def.id,
              formType: formState?.formType,
              formId: formState?.formId,
              screen: screenCurrentState?.screen,
              screenInstance: screenCurrentState?.instance,
            }

            let tableData = {
              uiContext,
              idField: def.database.dataIdField,
              idValue: rowId === undefined ? "" : rowId,
              clientId: state.ovl.app.clientId,
              insertMode: def.database.dbInsertMode,
              data: fixedData,
              filter,
              customData,
            }

            let postData: any = tableData

            let hasFiles = resFiles && resFiles.length > 0
            if (hasFiles) {
              let formData = new FormData()
              formData.append("tableData", JSON.stringify(postData))
              let uploadDefId = def.server.uploadDefId || def.server.endpoint
              if (uploadDefId) {
                formData.append("uploadDefId", uploadDefId)
              }
              resFiles.forEach((f, i) => {
                for (let z = 0; z < f.files.length; z++) {
                  formData.append(`${f.fieldKey}`, f.files[z])
                }
              })
              postData = formData
            }

            try {
              //if (def.server.endpoint) {
              if (processSnack) {
                ProcessRunningChangeSnack(
                  "SYSSaveRow",
                  processSnack,
                  processInstanceKey
                )
              }
              res = await Data(
                `${def.server.endpoint}/${endpoint}${
                  hasFiles ? "withfiles" : ""
                }`,
                postData,
                {
                  suppressFeedbackSnack: suppressFeedbackSnack === true,
                  isFormData: hasFiles,
                  process,
                }
              )
              if (!dataFormatCheck) {
                let resDataCheck =
                  res.data && res.data.data && res.data.data.length > 0
                if (res.data.rowFnResult || resDataCheck) {
                  dataFormatCheck = true
                  if (resDataCheck) {
                    resData = res.data.data[0]
                    newId = resData[def.database.dataIdField]
                    if (newId === undefined) {
                      dataFormatCheck = false
                    }
                  }
                } else {
                  dataFormatCheck = false
                }
              }
              if (!dataFormatCheck) {
                throw new Error("res.data wrong format")
              }
              ;(<OvlSysColumn>data.data[key].OvlSysState).rowState.originalId =
                rowId

              let serverRowFnResult = res.data.rowFnResult

              if (
                Array.isArray(serverRowFnResult) &&
                serverRowFnResult.length > 0
              ) {
                // the backend could deliver more than 1 result (to indicate stuff on other ids)

                for (let c = 0; c < serverRowFnResult.length; c++) {
                  let r = serverRowFnResult[c]
                  // if there is no r.id that means we tried to add a row and have no id... in that case the id is the current key
                  // the current result is the one with the same id
                  let tkey = data.index[r.id]

                  if (tkey === undefined || r.id === rowId.toString()) {
                    r.id = key
                    rowFnResult = r
                  } else {
                    r.id = tkey
                  }
                  await process.setFromResult(r)
                }
              }
              if (rowFnResult?.type === "error") {
                // handle already prepared errors in rowfnresult
                if (
                  rowFnResult.code === "UDTNameEmpty" ||
                  rowFnResult.code === "UDTNameUnique"
                ) {
                  if (hasFormState && formState.fields["Name"]) {
                    ValidationsAdd(
                      formState.fields["Name"],
                      "SYSEditUDTNameError",
                      "ValueChanged"
                    )
                  }
                }
              }
            } catch (res) {
              // 449 or 404 means offline in our context (depends on webserver. example on testwebserver i get the 449 on iis kaltag time i get 404 if an api endpoint is offline)
              if (res.status === 449 || res.status === 404) {
                // handle offline, had a case where i got 404 instead of expected 449 thats why i check it here as well
                // we need a ref already
                if (SYSConfig.offline.enabled) {
                  if (!isOfflineRetry) {
                    EditSaveRowOfflineHelper(
                      def,
                      data,
                      newData,
                      isAdd,
                      rowId,
                      key
                    )

                    let destRow = data.data[key]
                    Object.keys(newData).forEach((k) => {
                      destRow[k] = newData[k]
                    })
                    // new 17.07.2024
                    // offline stuff will be handled in custom polling
                    // so in this case just update the offline state so it can be handled lateron from custom  polling
                    data.data[key].OvlSysState.rowState.state = "Ok"
                    ;(<OvlSysColumn>(
                      data.data[key].OvlSysState
                    )).rowState.lastChangeBelongsToTableDefId = def.id
                    rowFnResult = {
                      type: "information",
                      id: key,
                      text: "queued for offline",
                    }
                    await process.setFromResult(rowFnResult)
                    results.results.push({ type: "success", key })
                    continue
                  } else {
                    // called from Offline handler and still offline
                    rowFnResult = {
                      type: "information",
                      id: key,
                      text: "still offline",
                    }
                    await process.setFromResult(rowFnResult)
                    results.results.push({ type: "error", key })
                    continue
                  }
                } else {
                  rowFnResult = {
                    type: "error",
                    id: key,
                    code: "OvlServerOffline",
                    text: `Server Offline (${res.status})`,
                    snacked: true,
                  }
                  //await process.setFromResult(rowFnResult)
                }
              } else {
                let msg = res.message
                if (!res.type) {
                  msg = `${res.status}:${msg}`
                }
                rowFnResult = {
                  type: "error",
                  id: key,
                  text: msg,
                  code: res.type,
                  snacked: res.snacked === true,
                  suppressFeedbackSnack: res.suppressFeedbackSnack === true,
                }
                //await process.setFromResult(rowFnResult)
              }
            }
          }
          // in any case call the TableSaveError Hook if there is an error
          if (rowFnResult?.type === "error") {
            if (/*hasFormState &&*/ fn && fn.hooks[HookTableSaveError]) {
              await fn.hooks[HookTableSaveError](<HookTableSaveError_Type>{
                rowFnResult: rowFnResult,
                originatingBatchKey,
                currentKey: key,
                def,
                data,
                res,
                formState,
                mode: isAdd ? "add" : "update",
                isOfflineRetry,
                resFiles,
              })
            }
            // in add the backend doesn't have an id when adding goes wrong
            if (!rowFnResult.id) {
              rowFnResult.id = key
            }
            results.results.push({ type: "error", key })
            await process.setFromResult(rowFnResult)
            continue
          }
          if (!rowFnResult) {
            // ok looks like we had a valid response
            rowFnResult = { type: "success", id: key }
          }
          if (def.server.endpoint && !state.ovl.app.offline.api) {
            DoRefreshLookups(actions, def, res?.data?.data, formState)
          }
          //here we get undefined because when we use
          if (resData[def.database.dataIdField] !== undefined) {
            rowId2 = resData[def.database.dataIdField]
          }
          // if it was an add but the new id already exists
          // then the backend decided to make an update
          // usecase attachments b&v
          // reload page -> goto activities -> refresh -> select an activity type -> drag and drop a file -> click on attachments -> then do the same
          // another usecase to be tested if following block changes: if a row gets added with code,name filled by seqid() which will not be changed on server (Manual Code) already its also the same (TableSaveRow API)
          if (isAdd) {
            let existingKey = data.index[rowId2]
            if (existingKey) {
              if (data.data[existingKey].OvlSysState.rowState.state !== "Add") {
                delete data.data[key]
                key = existingKey
                backendDecidedToMakeAnUpdateInsteadOfAdd = true
                data.data[key].OvlSysState.rowState.state = "Update"
              }
            }
          }
          destRow = data.data[key]

          // Object.keys(resData).forEach((k) => {
          //   if (destRow[k] !== resData[k]) {
          //     changed.columns.add(k)
          //   }
          //   destRow[k] = resData[k]
          // })

          // Object.keys(resData).forEach((k) => {

          changed = _DoServerDataConversionSyncAndBuildUpRebuildAndChangedInfo(
            key,
            data.clientConversion,
            resData,
            destRow,
            def.uiState.rebuild,
            isAdd && !backendDecidedToMakeAnUpdateInsteadOfAdd,
            mergeRowHookParams,
            data.checkForOtherModification,
            newData
          )
          //})

          data.data[key].OvlSysState.rowState.originalId = rowId2
        }
        let returnedKeys: Map<string, ServerData_ChangedType> = new Map()
        if (Object.keys(changed.columns).length > 0) {
          returnedKeys.set(key, changed)
        }
        _DoRebuildAndFixPage(def, true)
        if (!backendDecidedToMakeAnUpdateInsteadOfAdd) {
          // keep index and stuff up to date
          if (!rowId2) {
            rowId2 = (<OvlSysColumn>data.data[key].OvlSysState).rowState
              .originalId
          }
          if (rowId !== rowId2) {
            // key changed so lets update index
            delete data.index[rowId]
          }
          data.index[rowId2] = key
          // set all the tabledefs refresh indication if necessary
          if (isAdd) {
            def.uiState.rowsCount++
          }
          // if (!ignoreNeedsRefresh) {
          //   /*
          //     we should replace newData with the changedColumns
          //     and inside TablesNeedsRefresh check if one of zthe filters or sorts is touched by the changed columns
          //     we then should use _TablesNeedsRefresh as well from .setResult in ProcessApi Helper
          //   */
          //   _DoRebuildAndFixPage(def)
          // }
        }

        ;(data.data[key].OvlSysState as OvlSysColumn).rowState.state = "Ok"
        ;(<OvlSysColumn>(
          data.data[key].OvlSysState
        )).rowState.lastChangeBelongsToTableDefId = def.id

        let afterSaveFnName = HookTableAfterSave
        if (fn?.hooks?.[afterSaveFnName]) {
          await fn.hooks[afterSaveFnName]({
            key,
            def,
            data,
            res: res.data,
            returnedKeys,
            isOfflineRetry,
            formState,
            resFiles,
          } as HookTableAfterSave_Type)
        }

        if (hasFormState && key === originatingBatchKey) {
          FormSetUnDirty(formState)
        }

        let tableServerDataFnName = HookTableServerData
        if (fn?.hooks?.[tableServerDataFnName]) {
          await fn.hooks[tableServerDataFnName](<HookTableServerData_Type>{
            more: false,
            ext: res.data.ext,
            type: "RefreshRow",
            tableData: data,
            tableDefId: def.id,
            returnedKeys,
          })
        }

        // this one nedds investigation
        // doesn't make senese because it gets set to ok a few lines down anyway
        // but i leave it here because this was an issue at some point in the past
        // if (backendDecidedToMakeAnUpdateInsteadOfAdd) {
        //   ;(data.data[key].OvlSysState as OvlSysColumn).rowState.state = "Ok"
        // }
      } catch (e) {
        // this should catch any errors within the for loop
        await process.setFromResult({
          id: key,
          type: "error",
          text: e.message || e,
        })
        results.results.push({ type: "error", key })
        continue
      }
      await process.setFromResult(rowFnResult)
      results.results.push({ type: "success", key })
      if (formState) {
        resFiles.forEach((resFile) => {
          formState.fields[resFile.fieldKey]._state._files = undefined
        })
      }
    }
  } finally {
    if (
      hasAtLeastOneServerSaved &&
      /*!noSnack &&*/
      results.results.filter((f) => f.type !== "beforesavehook_cancel").length >
        0
    ) {
      if (!parentProcess) {
        process.showSummary("Snack")
      }
    }

    def.uiState.currentlyAddingKey = undefined
    if (!parentProcess) {
      process.stop()
    }
    //ProcessEnd("SYSSaveRow", processInstanceKey)
  }
  if (
    results.results.filter(
      (f) => f.key === originatingBatchKey && f.type === "success"
    ).length > 0
  ) {
    results.changedFields = newData
  }

  return results
}

export const _TableOfflineHandler: SYSAction<
  {
    defId: SYSTableDefIds
  },
  Promise<number>
> = async (value, { global }) => {
  let state = global.getState()
  let actions = global.getActions()
  let tb = TableGet(value.defId)
  let data = tb.dataDef
  let operations = 0
  if (
    !data.offline ||
    data.offline.offlineHandlerInProcess ||
    !data.tableDef[value.defId].initialised
  ) {
    return 0
  }
  data.offline.offlineHandlerInProcess = true

  try {
    //state.ovl.app.offlineLastRetry = dn
    let defId = value.defId
    let deletedKeys = data.offline.deletedKeys
    let errors = data.offline.errors

    let deletedKeysKeys = Object.keys(deletedKeys)
    let i = 0
    while (i < deletedKeysKeys.length) {
      let k = deletedKeysKeys[i]
      if (
        await actions.ovl.internal._TableOfflineRetryDeleteRow({
          data,
          defId,
          key: k,
        })
      ) {
        delete deletedKeys[k]
      } else {
        OfflineHandlerErrorHelper(
          "Error in _TableOfflineRetryDeleteRow",
          k,
          errors
        )
      }
      i++
    }

    let addedKeys = data.offline.addedKeys
    let addedKeysKeys = Object.keys(addedKeys)
    let updatedKeys = data.offline.updatedKeys
    let updatedKeysKeys = Object.keys(updatedKeys)
    let addAndUpdateSequence: {
      type: string
      key: string
      timestamp: number
    }[] = []
    addedKeysKeys.forEach((f) => {
      addAndUpdateSequence.push({
        type: "add",
        key: f,
        timestamp: addedKeys[f],
      })
    })
    updatedKeysKeys.forEach((f) => {
      addAndUpdateSequence.push({
        type: "update",
        key: f,
        timestamp: updatedKeys[f].timestamp,
      })
    })
    addAndUpdateSequence.sort((a, b) => a.timestamp - b.timestamp)
    i = 0

    while (i < addAndUpdateSequence.length) {
      let e = addAndUpdateSequence[i]
      let k = e.key
      if (e.type === "add") {
        let resKey: _TableEditSaveResultsType

        resKey = await actions.ovl.internal._TableOfflineRetrySaveRow({
          data,
          defId,
          rowToSave: data.data[k],
          key: k,
          isAdd: true,
        })
        operations++

        if (resKey.results[0].type === "beforesavehook_cancel") {
          // if an add gets canceled row needs to be removed
          TableRemoveRowFromData(defId, k)
          delete addedKeys[k]
        } else if (resKey.results[0].type === "success") {
          delete addedKeys[k]
        } else {
          OfflineHandlerErrorHelper(
            "Error in _TableOfflineRetrySave",
            k,
            errors
          )
        }
      } else {
        let resKey
        let rowToSave = {}
        Object.keys(updatedKeys[k].columns).forEach((f) => {
          rowToSave[f] = data.data[k][f]
        })
        resKey = await actions.ovl.internal._TableOfflineRetrySaveRow({
          data,
          defId,
          rowToSave,
          key: k,
          isAdd: false,
        })
        operations++
        if (resKey.results[0].type === "beforesavehook_cancel") {
          // do nothing in this case
        } else if (resKey.results[0].type === "success") {
          delete updatedKeys[k]
        } else {
          OfflineHandlerErrorHelper(
            "Error in _TableOfflineRetrySave",
            k,
            errors
          )
        }
      }
      i++
    }

    if (operations > 0) {
      //await TableRefresh(value.defId, { preferCache: false })
    }
    return operations
  } finally {
    data.offline.offlineHandlerInProcess = false
  }
}

const OfflineHandlerErrorHelper = (
  message: string,
  key: string,
  errors: any
) => {
  let err: [] = errors[key]
  let msg: string = message
  if (!err) {
    err = []
    errors[key] = err
  }
  if (err.indexOf(<never>msg) < 0) {
    err.push(<never>msg)
  }
}

export const _TableSelectCustomSort: SYSAction<{
  id: string
  def: SYSTableDef
}> = (value) => {
  if (value.def.uiState.sort.sortCustom.selected !== value.id) {
    value.def.uiState.sort.sortCustom.selected = value.id
  } else {
    value.def.uiState.sort.sortCustom.selected = ""
  }
  value.def.uiState.sort.sort.field = ""
}

export const _TableSelectColumnRangeFilter: SYSAction<{
  key: RangeFilterType
  value: any
  value2: any
  def: SYSTableDef
}> = (value) => {
  let def = value.def
  let selectedColumn = def.uiState.headerSelected

  let colDef = def.uiState.filter.columns[selectedColumn]

  colDef.rangeFilter.selected = value.key
  if (value.key === "none") {
    colDef.rangeFilter.val = undefined
  } else {
    colDef.rangeFilter.val = value.value
    if (value.key === "greaterThanOrEqual") {
      colDef.rangeFilter.val2 = value.value2
    } else {
      colDef.rangeFilter.val2 = undefined
    }
  }
}

export const _TableSelectFilterSort: SYSAction<{
  key: string
  defId: SYSTableDefIds
  instance: string
}> = async (value, { global }) => {
  let actions = global.getActions()
  let tableDef = TableGet(value.defId)
  let tableFn = actions.app.features[tableDef.def.feature]?.hooks?.[HookTableFn]
  if (tableFn) {
    if (
      await tableFn(<HookTableFn_Type>{
        TableDefId: value.defId,
        FnType: "TableSettingsApplyFilterSort",
        before: true,
        id: value.key,
        val1: tableDef.def.id,
      })
    ) {
      return false
    }
  }
  if (!(await _SetCurrentActiveTableSettingsFilter(value.key, value.defId))) {
    return
  }

  await TableRebuild(value.defId, { showProcess: true })
  if (tableFn) {
    await tableFn(<HookTableFn_Type>{
      TableDefId: value.defId,
      FnType: "TableSettingsApplyFilterSort",
      before: false,
      id: value.key,
      val1: tableDef.def.id,
    })
  }
}

export const _TableSelectColumnFilter: SYSAction<{
  list: any[]
  def: SYSTableDef
  columnKey: string
  exclusive: boolean
}> = async (value, { global }) => {
  let actions = global.getActions()
  let filter = value.def.uiState.filter.columns[value.columnKey].columnFilter
  filter.type = value.list.length > 0 ? "list" : "none"
  filter.list = value.list
  filter.exclusive = value.exclusive
}

export const _TableSelectAttributeFilter: SYSAction<{
  def: SYSTableDef
  attributeDefKey: string
  attributeKey: string
  active: boolean
}> = async (value) => {
  let filterState = value.def.uiState.filter.filterAttributes
  if (value.active) {
    if (!filterState[value.attributeDefKey]) {
      filterState[value.attributeDefKey] = { attributes: {} }
    }
    filterState[value.attributeDefKey].attributes[value.attributeKey] = true
  } else {
    if (filterState[value.attributeDefKey]) {
      delete filterState[value.attributeDefKey].attributes[value.attributeKey]
    }
  }
}

export const _TableSelectCustomFilter: SYSAction<{
  id: string
  active: boolean
  def: SYSTableDef
  innerEvent?: boolean
}> = async (value) => {
  // console.log(value.id, value.innerEvent)
  // console.trace()

  let def = value.def
  let id = value.id
  let filterCustom = def.uiState.filter.filterCustom
  if (filterCustom[id].active === value.active) {
    return
  }

  let filterForced = def.uiState.filter._forced?.custom?.filters
  let originalPersisted =
    def.uiState.filter._forced?._originalPersistedState.custom

  if (value.innerEvent === false) {
    if (filterForced?.[id]) {
      delete filterForced[id]
    }
    if (originalPersisted?.[id]) {
      delete originalPersisted[id]
    }
  }

  let groupKey = def.uiState.filter._initial_filterCustomFlat?.[id]?._groupKey
  let foundGroupDef = groupKey
    ? def.options.initial_filterCustom[groupKey]
    : undefined
  if (!filterCustom[id].active && value.active) {
    // make sure only one filter per group is active
    if (foundGroupDef && foundGroupDef.isOption) {
      await Promise.all(
        Object.keys(foundGroupDef.filters)
          .filter((f) => f !== id)
          .map(async (k) => {
            if (filterCustom[k]?.active || originalPersisted?.[k]?.active) {
              if (
                !(await TableCustomFilter(def.id, k, false, {
                  _innerEvent: value.innerEvent === true,
                }))
              ) {
                return
              }
            }
          })
      )
    }
    //value.def.uiState.filter.filter.showSelected = false
    filterCustom[id].active = true
  } else if (filterCustom[id].active && !value.active) {
    filterCustom[id].active = false
  }
}

export const _TableEditClose: SYSAction<{
  key: string
  tableDef: SYSTableDef
  data: SYSTableData
}> = (value, { global }) => {
  let actions = global.getActions()
  let state = global.getState()
  let ovlSysState = <OvlSysColumn>value.data.data[value.key]?.OvlSysState
  let editRow = ovlSysState?.editRow
  if (value.tableDef.options.edit.editType === "inline") {
    // try to get the next row which is in inline edit mode and set focus to that row
    let lastFocus
    let startIndex = value.tableDef.uiState.dataFilteredAndSorted.indexOf(
      value.key
    )
    if (startIndex > -1) {
      for (
        let z = startIndex + 1;
        z < value.tableDef.uiState.dataFilteredAndSorted.length;
        z++
      ) {
        let key = value.tableDef.uiState.dataFilteredAndSorted[z]
        let editRow2 = (<OvlSysColumn>value.data.data[key]?.OvlSysState)
          ?.editRow
        if (
          editRow2.selected &&
          state.ovl.forms["SYSTableRowEdit"][`${value.tableDef.id}_${key}`]
        ) {
          let elementToCheckForFirstFocusable = document.getElementById(
            `trow ${value.tableDef.id}_${key}`
          )
          let elToFocus =
            elementToCheckForFirstFocusable.querySelector(".ovl-focusable")
          if (elToFocus) {
            lastFocus = elToFocus.id
          }

          break
        }
      }
    }

    if (!lastFocus) {
      lastFocus = value.tableDef.uiState.editInlineLastFocus
    }
    if (lastFocus) {
      setTimeout(() => {
        FocusSet(lastFocus)
      }, 300)
    }
  }
  if (editRow) {
    editRow.selected = false
    editRow.mode = undefined
  }
  if (ovlSysState) {
    ovlSysState.rowState.state = "Ok"
  }
}

const TableSortsRefreshed = new Set<string>()
export const _OpenTableRowHeaderMenu: SYSAction<{
  tableDefId: SYSTableDefIds
}> = async (value, { global }) => {
  let state = global.getState()
  let instance = DialogIsOpen("SYSTableHeaderMenu", "1") ? "2" : "1"
  let tableDef = TableGet(value.tableDefId)
  let tableData = tableDef.dataDef
  if (!tableData.tableDef[value.tableDefId].initialised) {
    await TableInit(value.tableDefId)
  }
  let standalonestate = state.ovl.libState.tableRowHeaderMenu
  standalonestate[`tableDefId${instance}`] = value.tableDefId
  let filterSortPermissions = _GetFilterSortPermission(tableDef.def.id)
  let selectedHeader = tableDef.def.uiState.headerSelected
  if (selectedHeader) {
    let canTableSettingsFilterSort = filterSortPermissions.found
    let colInitialDef = tableDef.def.columns[selectedHeader]
    let colDef = tableDef.def.uiState.filter.columns[selectedHeader]
    if (
      colInitialDef.filter.rangeFilter !== undefined ||
      canTableSettingsFilterSort
    ) {
      let headerMenuFilterFields = _HeaderMenuFilterFields
      if (colInitialDef.filter.rangeFilter !== undefined) {
        if (colDef.rangeFilter === undefined) {
          colDef.rangeFilter = {
            selected: colInitialDef.filter.rangeFilter.selected,
            defaultFilterType:
              colInitialDef.filter.rangeFilter.defaultFilterType,
          }
        }
        let colEffectiveType = colInitialDef.type || "text"
        if (
          colEffectiveType === "text" ||
          colEffectiveType === "decimal" ||
          colEffectiveType === "int" ||
          colEffectiveType === "date" ||
          colEffectiveType === "time" ||
          colEffectiveType === "inttime" ||
          colEffectiveType === "datetime"
        ) {
          let colType = colEffectiveType
          if (colInitialDef.list) {
            colType = "text"
          }
          headerMenuFilterFields.HeaderMenuRangeFilterValue.type = colType
          headerMenuFilterFields.HeaderMenuRangeFilterValue.ui = JSON.parse(
            JSON.stringify(tableDef.def.columns[selectedHeader].ui)
          )
          headerMenuFilterFields.HeaderMenuRangeFilterValue.ui.noLabel = true
          headerMenuFilterFields.HeaderMenuRangeFilterValue.ui.selectIfFocused = true

          headerMenuFilterFields.HeaderMenuRangeFilterValue.value =
            colDef.rangeFilter ? colDef.rangeFilter.val : null
          headerMenuFilterFields.HeaderMenuRangeFilterValue2.type = colType
          headerMenuFilterFields.HeaderMenuRangeFilterValue2.ui = JSON.parse(
            JSON.stringify(headerMenuFilterFields.HeaderMenuRangeFilterValue.ui)
          )

          headerMenuFilterFields.HeaderMenuRangeFilterValue2.ui.noLabel = true
          headerMenuFilterFields.HeaderMenuRangeFilterValue2.ui.selectIfFocused = true
          headerMenuFilterFields.HeaderMenuRangeFilterValue2.value =
            colDef.rangeFilter ? colDef.rangeFilter.val2 : null

          headerMenuFilterFields.HeaderMenuRangeFilterType.value =
            colDef.rangeFilter ? colDef.rangeFilter.selected : "none"
        }
      }
      // for now keep TableSeetings_FilterSort just for 1st Instance (Not on the FilterSettings TableHeader eg.)
      if (canTableSettingsFilterSort && instance === "1") {
        let settingsTable = TableGet("SYSTableSettings_FilterSort", {
          byIdValue: tableDef.def.uiState.currentSelectedFilterSort,
        })

        let differentiator = _GetFilterSortDifferentiator(value.tableDefId)

        differentiator = differentiator === undefined ? null : differentiator

        // by setting staticfilter here, the dropdownlist of favorites and the edit favorites list will be correct by design
        settingsTable.staticFilterSetEntry("U_TableDefId", value.tableDefId)
        settingsTable.staticFilterSetEntry("U_Differentiator", differentiator)

        let tskey = JSON.stringify(`${value.tableDefId}${differentiator}`)
        if (!TableSortsRefreshed.has(tskey)) {
          try {
            await settingsTable.refresh({
              suppressBusySnack: true,
            })
            TableSortsRefreshed.add(tskey)
          } catch (e) {
            if (e.status !== 449) {
              throw e
            }
          }
        }

        if (settingsTable.def.initialised) {
          if (settingsTable.getKeys().length > 0) {
            headerMenuFilterFields.HeaderMenuSelectPersistedFilterSort.value =
              tableDef.def.uiState.currentSelectedFilterSort
          } else {
            headerMenuFilterFields.HeaderMenuSelectPersistedFilterSort.value =
              ""
          }
          if (
            filterSortPermissions.readLevel === "all" ||
            filterSortPermissions.readLevel === "company"
          ) {
            //make the selectfield editable so we get hitlist while typing
            headerMenuFilterFields.HeaderMenuSelectPersistedFilterSort.list.selectOnly = false
          }
        }

        let tid = "1"
        if (DialogIsOpen("SYSTableHeaderMenu", "1")) {
          tid = "2"
        }
        let tableDefId =
          state.ovl.libState.tableRowHeaderMenu[`tableDefId${tid}`]

        state.ovl.libState.tableSettings.filterSort.currentTableDefId =
          tableDefId
        let p = _GetFilterSortPermission(tableDefId)

        let filterSortTableDef = TableGet("SYSTableSettings_FilterSort")
        filterSortTableDef.def.features.multiSelect =
          p.modifyLevel === "all" || p.modifyLevel === "company"
        filterSortTableDef.def.features.multiDelete =
          filterSortTableDef.def.features.multiSelect
      } else {
        let tableDefId = state.ovl.libState.tableRowHeaderMenu[`tableDefId1`]

        state.ovl.libState.tableSettings.filterSort.currentTableDefId =
          tableDefId
      }
      await FormInit("SYSHeaderMenuFilter", headerMenuFilterFields, {
        formId: instance,
        feature: "SYSTableSettings",
        forceOverwrite: true,
        tableDefId: value.tableDefId,
        initialFocusFieldKey: "HeaderMenuRangeFilterValue",
      })
    }
  }

  DialogOpen("SYSTableHeaderMenu", { instance })
}
export const _TableSelectEndRow: SYSAction<{
  key: string
  def: SYSTableDef
  data: SYSTableData
}> = (value, { global }) => {
  let state = global.getState()
  let actions = global.getActions()
  TableSelectRow(value.def.id, value.key, {
    _innerEvent: true,
    modifiers: { altKey: false, shiftKey: false, ctrlKey: true },
    mode: "Select",
  })
}

export const _TableEditRow: SYSAction<{
  key: string
  def: SYSTableDef
  data: SYSTableData
  justGetFormState?: boolean
  formType?: SYSForm
  formId?: any
  initialFocusFieldKey?: any
  forceBigForm?: boolean
}> = async (value, { global }) => {
  let state = global.getState()
  let actions = global.getActions()
  // init editform explicitly with table values

  let def = value.def
  let instanceId = `${def.id}_${value.key}`

  let editType = def.options.edit.editType
  if (value.forceBigForm) {
    editType = "big"
  }
  let ovlSysState = <OvlSysColumn>value.data.data[value.key].OvlSysState

  if (ovlSysState.rowState.state === "Ok") {
    ovlSysState.rowState.state = "Update"
  }

  let editRow = ovlSysState.editRow
  let formState
  try {
    let formFields = getFormFieldsFromColumns(
      def,
      value.data.data[value.key],
      editType === "inline"
    )

    if (editRow === undefined) {
      editRow = { mode: "edit", selected: false }
    }

    if (editRow.mode === undefined) {
      if (ovlSysState.rowState.state === "Add") {
        editRow.mode = "add"
      } else {
        editRow.mode = "edit"
      }
    }

    let initForm: InitFormType = {
      tableRowKey: value.key,
      fields: formFields,
      formType: value.formType ? value.formType : "SYSTableRowEdit",
      formId: value.formId ? value.formId : instanceId,
      feature: def.feature,
      forceKeepFormStateOnCancel: def.options.forceKeepFormStateOnCancel,
      doFormChangedForEveryFieldInInit:
        def.options.edit.doFormChangedForEveryFieldInInit,
      forceOverwrite: false,
      tableDefId: def.id,
      tableDataMode: editRow.mode === "edit" ? "Update" : "Add",
      isInline: editType === "inline",
      row: value.data.data[value.key],
      initialFocusFieldKey: value.initialFocusFieldKey,
      useAlignRight:
        def.options.rendering.controls.useAlignRight ?? editType === "inline",
    }

    formState = await actions.ovl.form._InitForm(initForm)
    def.uiState.formType = formState.formType
    def.uiState.formId = formState.formId

    if (value.justGetFormState) {
      return formState
    }

    if (editType === "big") {
      return await actions.ovl.dialog._DialogOpen({
        dialogType: "SYSTableRowEdit",
        data: <_TableRowEditFormType>{
          editMode: editRow.mode,
          tableDefId: def.id,
          key: value.key,
          formInitialised: true,
        },
        instance: `${def.id}_${value.key}`,
      })
    } else if (editType === "inline") {
      let focusState: _FocusState
      let currentDialogs = DialogCurrentState()
      if (currentDialogs.length === 0) {
        focusState = ScreenCurrentState()?.focus
      } else {
        focusState = currentDialogs[0].focus
      }
      focusState.focusWhenLeft = undefined
      editRow.selected = true
      def.uiState.editInlineLastFocus = document.activeElement.id

      // if inline called for a key not in the table
      // 3.1.24: trying to understand this old code. most probably necessary because we have multiedit and the selected row could be outside of the display
      _AddRowToDisplayedArray(def, formState.tableRowKey)
      return formState
    }
  } catch (e) {
    // remove any row if add an exception in init
    if (!e.snacked) {
      SnackAdd(e.message || e, "Error")
    }
    console.error(e)
    await _TableFormCloseEditRow(def.id, value.key)
  }
}

export const _TableMoreRow: SYSAction<{
  key: string
  def: SYSTableDef
  data: SYSTableData
}> = (value, { global }) => {
  let actions = global.getActions()
  actions.ovl.internal._TableSelectHeader({
    def: value.def,
    data: value.data,
    key: value.def.uiState.firstVisibleColumn,
  })
  actions.ovl.table._OpenTableRowHeaderMenu({
    tableDefId: value.def.id,
  })
}

export const _TableViewRow: SYSAction<{
  key: string
  def: SYSTableDef
  data: SYSTableData
}> = (value) => {
  let def = value.def
  //def.uiState.viewRow[value.key].selected = true
}
export const _TableCloseViewRow: SYSAction<{
  key: string
  def: SYSTableDef
}> = (value) => {
  let def = value.def

  //def.uiState.viewRow[value.key].selected = false
}

export const _TableCopyRow: SYSAction<
  {
    key: string
    def: SYSTableDef
    data: SYSTableData
    // indicates that there is no column def and alll the fields should be copied
    ignoreDef?: boolean
  },
  Promise<_TableAddRowReturnType<any>>
> = async (value, { global }) => {
  let actions = global.getActions()
  let def = value.def
  let key = value.key
  let rows = value.data.data
  let row = rows[value.key]
  let newRow
  if (value.ignoreDef) {
    newRow = JSON.parse(JSON.stringify(row))
  } else {
    newRow = Object.keys(def.columns)
      .filter((c) => {
        let col = def.columns[c]
        let valid = true
        if (
          col.schema?.isCalculatedColumn ||
          col.ui.visibility.indexOf("Edit") < 0
        ) {
          valid = false
        }
        return valid
      })
      .reduce((val, k) => {
        val[k] = row[k]
        return val
      }, {})
  }
  // Object.keys(def.options.copyColumnsIgnore).forEach((c) => {
  //   newRow[c] = null
  // })
  // and now use regular addrow which also adds static filter, default uiState in def ()
  return await actions.ovl.table._TableAddRow({
    data: value.data,
    def: value.def,
    mode: "copy",
    newRow,
    fromKey: key,
  })
}

export const _TableAddRow: SYSAction<
  {
    def: SYSTableDef
    data: SYSTableData
    // following 3 params are in use when called from _TableCopyRow
    mode?: EditMode
    newRow?: {}
    fromKey?: string
  },
  Promise<_TableAddRowReturnType<any>>
> = async (value, { global }) => {
  let actions = global.getActions()
  let def = value.def
  let newKey
  let mode = value.mode
  if (mode === undefined) {
    mode = "add"
  }
  let newRow = value.newRow
  if (newRow === undefined) {
    newRow = {}
  }
  let addResult: HookFormAdd_ReturnType
  try {
    // we always want static filter to already be included in the new row
    if (def.uiState.filter.filter.static) {
      newRow = Object.keys(def.uiState.filter.filter.static).reduce(
        (val, key) => {
          val[key] = def.uiState.filter.filter.static[key]
          return val
        },
        newRow
      )
    }
    newRow = Object.keys(def.columns).reduce((val, key) => {
      if (newRow[key] === undefined) {
        let column = def.columns[key]
        let uiStateFilterColumn = def.uiState.filter.columns[key]

        if (column) {
          // if there is a single columnfilter use that value
          let columnFilter = uiStateFilterColumn.columnFilter
          if (
            columnFilter &&
            columnFilter.list &&
            columnFilter.list.length === 1 &&
            !columnFilter.exclusive
          ) {
            val[key] = columnFilter.list[0]
          }
          if (column.nullHandling.setToValueIfNull !== undefined) {
            val[key] = column.nullHandling.setToValueIfNull
          }
          // also take care of default values
          if (column.schema?.defaultValue !== undefined) {
            newRow[key] = column.schema.defaultValue
          }
        }
      }
      return val
    }, newRow)

    // now if there are default values from schema use them as well if row doesnt have a value already
    // imo always use schema if there regardless the useSchema setting
    let schema = value.data.schema
    if (schema) {
      Object.keys(schema).forEach((f) => {
        if (
          f !== def.database.dataIdField &&
          newRow[f] === undefined &&
          schema[f]?.defaultValue !== undefined &&
          schema[f]?.defaultValue !== null
        ) {
          if (
            !def.database.onlyUseDefinedColumnsForSchemaDefaultValues ||
            def.columns[f]
          ) {
            newRow[f] = schema[f].defaultValue
          }
        }
      })
    }
    // addRow (Default Values) @@hook
    let fn = actions.app.features[def.feature]
    let addFnName = HookFormAdd

    if (fn?.hooks?.[addFnName]) {
      addResult = await fn.hooks[addFnName](<HookFormAdd_Type>{
        newRow,
        tableDef: def,
        tableData: value.data,
        copyFromKey: value.fromKey,
      })
      if (addResult?.cancelAction) {
        return
      }
    }

    newKey = SYSSeqId()

    def.uiState.currentlyAddingKey = newKey
    if (def.database.dbInsertMode.indexOf("Manual") < 0) {
      newRow[def.database.dataIdField] = newKey
    }
    // value.data.data[newKey].OvlSysState.rowState = {
    //   originalId: newRow[def.database.dataIdField],
    //   state: "Add",
    // }

    newRow["OvlSysState"] = _GetOvlSysColDefault()
    let ovlSysState = newRow["OvlSysState"] as OvlSysColumn
    ovlSysState.rowState.originalId = newRow[def.database.dataIdField]
    ovlSysState.rowState.state = "Add"
    if (value.fromKey) {
      ovlSysState.editRow.mode = "copy"
      ovlSysState.editRow.fromKey = value.fromKey
    }

    value.data.data[newKey] = newRow

    // its important to do the following inits
    // because the rows will get tracked in rowwrapper
    def.uiState.selectedRow[newKey] = {
      selected: false,
      showNav: false,
      count: 0,
    }
    def.uiState.tableGroupHeaderBreaks[newKey] = {
      groups: {},

      isBreak: false,
      isFirstRow: false,
      isLastRow: false,
    }

    def.uiState.tableGroupFooterBreaks[newKey] = {
      groups: {},

      isBreak: false,
      isFirstRow: false,
      isLastRow: false,
    }
  } catch (e) {
    if (newKey) {
      TableRemoveRowFromData(def.id, newKey)
    }
    throw e
  }
  return { newRow, key: newKey, fieldKeyToFocus: addResult?.fieldKeyToFocus }
}

export const _TableOfflineRetryDeleteRow: SYSAction<
  {
    data: SYSTableData
    defId: SYSTableDefIds
    key: string
  },
  Promise<boolean>
> = async (value, { global }) => {
  let actions = global.getActions()
  let data = value.data

  let def = data.tableDef[value.defId]
  if (value.data.offline.deletedKeys[value.key]) {
    return await actions.ovl.table._TableDeleteRow({
      key: value.key,
      def,
      data,
      isOfflineRetry: true,
    })
  }
}

const DeleteRowOfflineHelper = (data: SYSTableData, key: string): boolean => {
  let deletedKeys = data.offline.deletedKeys
  // if its an offline key no delete necessary
  // means that if this row is only offline handled there is no need for a server delete
  let isOfflineKey = false

  if (data.offline.addedKeys[key] || data.offline.updatedKeys[key]) {
    isOfflineKey = true
  }
  if (!isOfflineKey && ovl.getState().ovl.app.offline.api) {
    deletedKeys[key] = key
  }

  // its a record that was added before in offline mode...so just remove it from the add list (did not hit the server yet)
  delete data.offline.addedKeys[key]
  // any offline updates are now obsolete as well
  delete data.offline.updatedKeys[key]
  return isOfflineKey
}

export const _CancelRowFn: SYSAction<{
  fnKey: string
  clientId: string
}> = async (value, { global }) => {
  let state = global.getState()
  await postRequest(state.ovl.apiUrl + "users/cancelrowfn", {
    fnKey: value.fnKey,
    clientId: value.clientId,
  })
}

export const _TableDeleteRow: SYSAction<
  {
    key: string
    def: SYSTableDef
    data: SYSTableData
    noPrompt?: boolean
    multi?: { isFirst: boolean; isLast: boolean }
    isOfflineRetry?: boolean
    process?: _ProcessReturnType
  },
  Promise<boolean>
> = async (value, { global }) => {
  let state = global.getState()
  let actions = global.getActions()
  let def = value.def
  let key = value.key

  let idValue = (<OvlSysColumn>value.data.data[key].OvlSysState).rowState
    .originalId
  if (SYSConfig.offline.enabled && DeleteRowOfflineHelper(value.data, key)) {
    value.process.setSuccess(key)
    deleteTableRow({ def: def, data: value.data }, key)
    return true
  }

  let deletedRow = JSON.parse(JSON.stringify(value.data.data[value.key]))
  let fn = actions.app.features[def.feature]
  let beforeDeleteResult: HookTableBeforeDelete_ReturnType = {
    resolve: "Continue",
  }
  let rowFnResult: TableRowFnProcessRawFeedback_Type = { type: undefined }
  if (fn?.hooks?.[HookTableBeforeDelete]) {
    let res: HookTableBeforeDelete_ReturnType = await fn.hooks[
      HookTableBeforeDelete
    ](<HookTableBeforeDelete_Type>{
      key,
      row: deletedRow,
      idValue,
      isOfflineRetry: value.isOfflineRetry,
      tableDefId: def.id,
    })
    if (res !== undefined) {
      beforeDeleteResult = res
    }
    if (res.rowFnResult) {
      rowFnResult = res.rowFnResult
    }
  }
  if (beforeDeleteResult.resolve === "Cancel") {
    if (value.process) {
      value.process.setSuccess(value.key)
    }
    return true
  }

  if (beforeDeleteResult.resolve === "DeleteLocally") {
    if (value.process) {
      value.process.setSuccess(value.key)
    }
    deleteTableRow({ def: def, data: value.data }, key)
    def.uiState.rowsCount--
    let afterDeleteFnName = HookTableAfterDelete
    if (fn?.hooks?.[afterDeleteFnName]) {
      await fn.hooks[afterDeleteFnName](<HookTableAfterDelete_Type>{
        key,
        def: def,
        data: value.data,
        res: undefined,
        deletedRow,
        isOfflineRetry: value.isOfflineRetry,
      })
    }

    return true
  }

  let res = { data: undefined, status: undefined, type: undefined }

  try {
    if (beforeDeleteResult.resolve === "Continue") {
      let screenCurrentState = ScreenCurrentState()
      let uiContext: UIContextType = {
        feature: <string>def.feature,
        tableDefId: def.id,
        formType: undefined,
        formId: undefined,
        screen: screenCurrentState?.screen,
        screenInstance: screenCurrentState?.instance,
      }

      res = await postRequest(
        state.ovl.apiUrl + def.server.endpoint + "/delete",
        {
          idField: def.database.dataIdField,
          clientId: state.ovl.app.clientId,
          idValue,
          insertMode: def.database.dbInsertMode,
          uiContext,
          customData: beforeDeleteResult.customPostData,
        },
        undefined,
        !!value.process
      )
    }
    let serverRowFnResult = res.data?.rowFnResult

    if (Array.isArray(serverRowFnResult) && serverRowFnResult.length > 0) {
      // the backend could deliver more than 1 result (to indicate stuff on other ids)
      await Promise.all(
        serverRowFnResult.map(async (r) => {
          if (r.id === idValue.toString()) {
            rowFnResult = r
            rowFnResult.id = key
          }
          await value.process.setFromResult(r)
        })
      )
    } else {
      if (!rowFnResult.type) {
        // if there is no rowFnResult from backend its a success
        rowFnResult = { type: "success", id: key }
      }
      //await value.process.setFromResult(rowFnResult)
    }
    // set focus back to row before (because if the focuss conatining element gets removed focus gets set wrongly)

    if (rowFnResult.type !== "error") {
      def.uiState.rowsCount--
      try {
        let afterDeleteFnName = HookTableAfterDelete
        if (fn?.hooks?.[afterDeleteFnName]) {
          await fn.hooks[afterDeleteFnName](<HookTableAfterDelete_Type>{
            key,
            def: def,
            data: value.data,
            res: res.data,
            deletedRow,
            isOfflineRetry: value.isOfflineRetry,
          })
        }
      } catch (hookErr) {
        rowFnResult.type = "error"
        rowFnResult.text = hookErr
      }

      if (rowFnResult.type !== "error") {
        let cidx = def.uiState.dataFilteredAndSorted.indexOf(key)
        if (cidx > 0) {
          cidx--
        }
        let newkey = def.uiState.dataFilteredAndSorted[cidx]
        let elementToFocus: HTMLElement = document.querySelector(
          `ovl-trow[data-rowkey="${newkey}"]`
        )
        if (elementToFocus) {
          elementToFocus.focus()
        } else {
          // focus an table header
          elementToFocus = document.querySelector(`.header__${def.id}`)
          if (elementToFocus) {
            elementToFocus.focus()
          }
        }

        //if (!value.isOfflineRetry) {
        deleteTableRow({ def: def, data: value.data }, key)
        if (!value.multi || value.multi.isLast) {
          if (
            def.features.autoRebuild === "AfterModifyOrDelete" ||
            def.features.autoRebuild === "AfterModifyOrDeleteOrAdd"
          ) {
            TableRebuild(def.id)
          }
        }
        //}
      }
    }

    // afterDelete @@hook
  } catch (res) {
    if (res.type !== "RecordNotFound") {
      // 449 means offline in our context
      if (res.status === 449 && SYSConfig.offline.enabled) {
        rowFnResult.type = "success"
        //value.process.setSuccess(value.key)
        if (!value.isOfflineRetry) {
          DeleteRowOfflineHelper(value.data, key)
        } else {
          // if we are coming from offline retry and still offiline -> no success (OfflineHandler should know that...)
          rowFnResult.type = "information"
          rowFnResult.text = "still offline"
          if (value.process) {
            value.process.setFromResult(rowFnResult)
            //Offlinehandler should retry. if returning true it would be handled which is wrong
            return false
          }
        }
      } else {
        let msg = res.message
        if (!res.type) {
          msg = `${res.status}:${msg}`
        }
        rowFnResult = {
          type: "error",
          id: key,
          text: msg,
          code: res.type,
        }
      }
      if (rowFnResult.type === "error") {
        // handleError @@hook
        let fn = actions.app.features[def.feature]
        let deleteErrorFnName = HookTableDeleteError
        if (fn?.hooks?.[deleteErrorFnName]) {
          // @todo test
          await fn.hooks[deleteErrorFnName](<HookTableDeleteError_Type>{
            rowFnResult,
            key,
            tableDef: def,
            res,
          })
        }
      }
    }
  }

  if (value.process) {
    value.process.setFromResult(rowFnResult)
  }
  if (rowFnResult.type === "error") {
    return false
  } else {
    return true
  }
}
// export const _TableMultipleDeleteRow: SYSAction<{
//   def: SYSTableDef
//   data: SYSTableData
// }> = async (value, { global }) => {
//   let actions = global.getActions()
//   let def = value.def
//   let deletedCounter = 0
//   let fnName = T("SYSTableRowFnDelete")
//   let validateAndPromptResult = await ValidateAndPrompt(
//     "OvlDelete",
//     fnName,
//     actions,
//     def,
//     value.data,
//     true,
//     undefined
//   )
//   if (validateAndPromptResult.cancel) {
//     return
//   }
//   let selectedObjects = validateAndPromptResult.selectedObjects
//   if (selectedObjects.length > 0) {
//     def.uiState.headerSelected = ""

//     let multiHint = T("SYSTableRowFnProcessRowFnHint", selectedObjects.length)
//     let process = ProcessStart("SYSTableRowFnProcess", {
//       instance: `${def.id}_OvlSep_Delete_OvlSep_Multi`,
//       snack: {
//         text: T("SYSTableRowFnProcess", [fnName, multiHint]),
//         type: "BusyIndicator",
//       },
//       tableFn: {
//         fnId: "OvlDelete",
//         tableDefId: def.id,
//         fnName,
//         rowKey: undefined,
//         lockedTableKeys: selectedObjects.reduce((val, k) => {
//           val[k] = true
//           return val
//         }, {}),
//       },
//     })
//     try {
//       let i = 0

//       for (let k of selectedObjects) {
//         let idValue = value.data.data[k][def.database.dataIdField]
//         if (
//           await actions.ovl.internal._TableDeleteRow({
//             key: k,
//             def: def,
//             data: value.data,
//             multi: {
//               isFirst: i === 0,
//               isLast: i === selectedObjects.length - 1,
//             },
//             multiProcess: process,
//           })
//         ) {
//           process.setSuccess(idValue)
//         }
//         i++
//       }
//       process.showSummary(T("SYSTableRowFnProcessRowFnPositions"))
//     } finally {
//       process.stop()
//     }
//   }
// }

// export const _TableMultipleCopyRow: SYSAction<{
//   def: SYSTableDef
//   data: SYSTableData
// }> = async (value, { global }) => {
//   let state = global.getState()
//   let actions = global.getActions()
//   let def = value.def
//   let validateAndPromptResult = await ValidateAndPrompt(
//     "OvlCopy",
//     T("SYSTableRowFnCopyMulti"),
//     actions,
//     def,
//     value.data,
//     true,
//     undefined
//   )
//   if (validateAndPromptResult.cancel) {
//     return
//   }
//   let selectedObjects = validateAndPromptResult.validKeys
//   if (selectedObjects.length > 0) {
//     def.uiState.headerSelected = ""
//     let wait = Promise.all(
//       selectedObjects.map(async (k) => {
//         let copyRes = await actions.ovl.internal._TableCopyRow({
//           key: k,
//           def: def,
//           data: value.data,
//         })
//         await actions.ovl.internal._TableEditRow({
//           key: k,
//           def: def,
//           data: value.data,
//           initialFocusFieldKey: copyRes.fieldKeyToFocus,
//         })
//       })
//     )
//     await wait
//   }
// }

export const _TableMultipleEditRow: SYSAction<{
  def: SYSTableDef
  data: SYSTableData
}> = async (value, { global }) => {
  let state = global.getState()
  let actions = global.getActions()
  let def = value.def
  let validateAndPromptResult = await ValidateAndPrompt(
    "Edit",
    T("SYSTableRowFnEdit"),
    actions,
    def,
    value.data,
    true,
    undefined
  )
  if (validateAndPromptResult.cancel) {
    return
  }
  let selectedObjects = validateAndPromptResult.validKeys
  if (selectedObjects.length > 0) {
    let wait = Promise.all(
      selectedObjects.map(async (k) => {
        //def.uiState.editRow[k].mode = "edit"
        await actions.ovl.table._TableEditRow({
          key: k,
          def: def,
          data: value.data,
        })
      })
    )
    await wait
  }
}

export const _TableMultipleCustomFunction: SYSAction<{
  def: SYSTableDef
  data: SYSTableData
  customFnId: string
  customSelection?: string[]
  validKeys?: string[]
  fromOfflineHandler?: boolean
}> = async (value, { global }) => {
  let actions = global.getActions()
  let state = global.getState()
  let tb = TableGet(value.def.id)
  let selectedRows =
    value.customSelection === undefined
      ? tb.getKeys({ byKeys: "Selected" })
      : value.customSelection

  let fromTableFn = selectedRows.length === 0
  let def = value.def
  let data = value.data
  let customFnDef = def.options.customRowActions[value.customFnId]
  let translationKey = customFnDef.translationKey
  let fnName = T(translationKey)
  let usePrompt = customFnDef.prompt
  let callForEveryRow = customFnDef.whenMultiple?.callForEveryRow

  let validateAndPromptResult: validateAndPromptResultType
  if (!value.fromOfflineHandler) {
    validateAndPromptResult = await ValidateAndPrompt(
      value.customFnId,
      fnName,
      actions,
      def,
      value.data,
      usePrompt.type.startsWith("WhenMulti") || usePrompt.type === "Always",
      customFnDef.whenMultiple?.optionalPositionTranslationCode,
      customFnDef.whenMultiple?.grouped?.byColumn,
      selectedRows,
      value.validKeys
    )
  } else {
    validateAndPromptResult.selectedObjects = value.customSelection
    validateAndPromptResult.validKeys = value.customSelection
  }

  if (validateAndPromptResult.cancel) {
    return
  }
  let selectedObjects = validateAndPromptResult.validKeys

  def.uiState.headerSelected = ""
  let customFns = actions.app.features[def.feature]
  let customFunctionName = HookTableRowFn
  let customFunction = customFns.hooks[customFunctionName]
  let process: _ProcessReturnType
  let trackStatusIntervall = { id: -1 }
  if (
    customFunction ||
    customFnDef?.endpoint?.url ||
    value.customFnId === "SYSDelete" ||
    value.customFnId === "SYSCopy" ||
    value.customFnId === "SYSEdit"
  ) {
    if (customFnDef.process !== "None") {
      // if we don't use default process check if there is also a specific hint
      let hintTranslationKey = `${customFnDef.process}RowFnHint`
      if (!state.ovl.language.translations[hintTranslationKey]) {
        hintTranslationKey = "SYSTableRowFnProcessRowFnHint"
      }
      let multiHint
      if (!fromTableFn) {
        multiHint = T(hintTranslationKey, selectedObjects.length)
      } else {
        multiHint = ""
      }
      let snack: ProcessSnackType
      if (
        !(
          value.customFnId === "OvlDelete" &&
          def.features.saveLocallyMode === "SaveLocally"
        )
      ) {
        snack = {
          text: T(customFnDef.process, [fnName, multiHint]),
          type: "BusyIndicator",
          cancelable:
            customFnDef.cancelable && Object.keys(selectedObjects).length > 1,
        }
      }

      process = ProcessStart(customFnDef.process, {
        instance: `${def.id}_OvlSep_${value.customFnId}_OvlSep_Multi`,
        snack,
        tableFn: {
          fnId: value.customFnId,
          tableDefId: def.id,
          fnName: fnName,
          rowKey: undefined,
          lockedTableKeys: selectedObjects.reduce((val, k) => {
            val[k] = true
            return val
          }, {}),
        },
      })
    }

    try {
      let connectedConfirmFormState
      if (validateAndPromptResult.connectedFormBehaviour?.formType) {
        connectedConfirmFormState = FormGet(
          <SYSForm>validateAndPromptResult.connectedFormBehaviour.formType,
          {
            instance: validateAndPromptResult.connectedFormBehaviour.formId,
          }
        )
      }

      let fnResultToSet: RowFunctionResultToSet = _GetFnResultToSet(
        value.customFnId,
        process,
        data
      )
      let trackingPromise: Promise<boolean>
      let clientId = state.ovl.app.clientId
      if (process && customFnDef.trackData !== "None") {
        trackingPromise = _handleRowFnTracking(
          customFnDef.trackData,
          trackStatusIntervall,
          value.customFnId,
          clientId,
          process,
          fnResultToSet,
          fnName
        )
      }
      if (callForEveryRow) {
        for (let z = 0; z < selectedObjects.length; z++) {
          let k = selectedObjects[z]
          if (process?.trackedSnackId) {
            if (process.cancelled) {
              break
            } else {
              SnackTrackedReplaceContent({
                key: process.trackedSnackId,
                content: T(customFnDef.process, [
                  fnName,
                  `(${z + 1} / ${selectedObjects.length})`,
                ]),
              })
            }
          }
          if (value.customFnId === "SYSDelete") {
            await actions.ovl.internal._TableDeleteRow({
              key: k,
              def: def,
              data: value.data,
              multi: {
                isFirst: z === 0,
                isLast: z === selectedObjects.length - 1,
              },
              process: process,
            })
          } else if (value.customFnId === "SYSCopy") {
            let res = await actions.ovl.internal._TableCopyRow({
              key: k,
              def: def,
              data: value.data,
            })
            await ovl
              .getActions()
              .ovl.table._TableEditRow({ key: res.key, data, def })
          } else if (value.customFnId === "SYSEdit") {
            await actions.ovl.internal._TableEditRow({
              key: k,
              def: def,
              data: value.data,
            })
          } else {
            if (customFnDef?.endpoint?.url) {
              await _handleRowFnEndpointData(
                value.customFnId,
                clientId,
                customFnDef.endpoint.url,
                fnResultToSet,
                data,
                def,
                [k],
                connectedConfirmFormState,
                process,
                undefined
              )
            } else {
              await customFunction(<HookTableRowFn_Type>{
                fnKey: value.customFnId,
                isSingle: true,
                rowKey: k,
                def: def,
                data: data,
                row: data.data[k],
                rows: data.data,
                selectedKeys: selectedObjects,
                resultToSet: fnResultToSet,
                connectedConfirmFormState,
              })
            }
          }
        }
      } else {
        if (customFnDef?.endpoint?.url) {
          await _handleRowFnEndpointData(
            value.customFnId,
            clientId,

            customFnDef.endpoint.url,
            fnResultToSet,
            data,
            def,
            selectedObjects,
            connectedConfirmFormState,
            process,
            trackingPromise
          )
        } else {
          // callForEveryRow = false => just call once
          await customFunction(<HookTableRowFn_Type>{
            fnKey: value.customFnId,
            isSingle: false,
            def: def,
            data: data,
            rows: data.data,
            selectedKeys: selectedObjects,
            resultToSet: fnResultToSet,
            connectedConfirmFormState,
          })
        }
      }
      if (
        !(
          value.customFnId === "OvlDelete" &&
          def.features.saveLocallyMode === "SaveLocally"
        ) &&
        !value.fromOfflineHandler &&
        customFnDef.summary !== "None" &&
        process
      ) {
        process.showSummary(
          customFnDef.summary,
          validateAndPromptResult.positionText
        )
      }
      if (process) {
        _handleRowFnConfirmFieldsReset(
          validateAndPromptResult?.connectedFormBehaviour,
          process?.currentFeedback
        )
        // if (
        //   def.uiState.rebuild.needsRefresh &&
        //   ((def.uiState.rebuild.modified &&
        //     (def.features.autoRebuild === "AfterModifyOrDelete" ||
        //       def.features.autoRebuild === "AfterModifyOrDeleteOrAdd")) ||
        //     (def.uiState.rebuild.added &&
        //       def.features.autoRebuild === "AfterModifyOrDeleteOrAdd"))
        // ) {
        //   TableRebuild(def.id)
        // }
        _DoRebuildAndFixPage(def, true)
      }
    } finally {
      if (process) {
        clearInterval(trackStatusIntervall.id)
        process.stop()
      }
    }
  }

  // if (result) {
  //   await DialogOk(result)
  // }
}

type validateAndPromptResultType = {
  validKeys: string[]
  selectedObjects: string[]
  cancel: boolean
  connectedFormBehaviour: {
    formType: string
    formId: string
    fieldsResetType: RowFnConfirmContentFieldsReset_Type
  }
  positionText: string
}
const ValidateAndPrompt = async (
  customFnId: string,
  fnName: string,
  actions: SYSActions,
  def: SYSTableDef,
  data: SYSTableData,
  usePrompt: boolean,
  optionalPositionTranslationCode?: string,
  groupedByColumn?: string,
  selectedRows?: string[],
  validKeys?: string[]
): Promise<validateAndPromptResultType> => {
  let functionName = HookTableRowFnCan
  let fnc = actions.app.features[def.feature]
  let tb = TableGet(def.id)

  let result: validateAndPromptResultType = {
    validKeys: [],
    selectedObjects: selectedRows,
    cancel: false,
    connectedFormBehaviour: undefined,
    positionText: "",
  }
  let fromTableFn = selectedRows.length === 0
  let functionsToSetTemplate = _GetRowFnToSet(def, "All")
  if (validKeys && validKeys.length > 0) {
    for (let i = 0; i < validKeys.length; i++) {
      let functionsToSet = JSON.parse(JSON.stringify(functionsToSetTemplate))
      let k = validKeys[i]
      // we already have done the principal check, just do the processcheck here
      _DoRowFnProcessRunningCheck(functionsToSet, def, k, undefined)
      if (
        functionsToSet?.[customFnId] === undefined ||
        functionsToSet?.[customFnId]?.visibility === "Visible"
      ) {
        result.validKeys.push(k)
      }
    }
  } else {
    for (let i = 0; i < selectedRows.length; i++) {
      let functionsToSet = JSON.parse(JSON.stringify(functionsToSetTemplate))
      let k = selectedRows[i]
      if (fnc && fnc.hooks[functionName]) {
        await fnc.hooks[functionName](<HookTableRowFnCan_Type>{
          _functionsToSet: functionsToSet,
          rowKey: k,
          tableDef: def,
          tableData: data,
          row: data.data[k],
          set: (fnKey: string, options: {}) => {
            _tableRowFnSetHelper(fnKey, options, functionsToSet)
          },
        })
      }

      _DoRowFnProcessRunningCheck(functionsToSet, def, k, undefined)
      if (
        functionsToSet?.[customFnId] === undefined ||
        functionsToSet?.[customFnId]?.visibility === "Visible"
      ) {
        result.validKeys.push(k)
      }
    }
  }
  if (groupedByColumn) {
    result.positionText = optionalPositionTranslationCode
      ? T(optionalPositionTranslationCode)
      : T("SYSTableRowFnProcessRowFnGroups")
    let groups = selectedRows.reduce((val, k) => {
      if (!val[tb.rows[k][groupedByColumn]]) {
        val[tb.rows[k][groupedByColumn]] = {
          validKeys: [],
          selectedObjects: [],
        }
      }
      if (result.validKeys.indexOf(k) > -1) {
        val[tb.rows[k][groupedByColumn]].validKeys.push(k)
      }
      val[tb.rows[k][groupedByColumn]].selectedObjects.push(k)
      return val
    }, {})
    result.selectedObjects = []
    result.validKeys = []
    Object.keys(groups).forEach((k) => {
      if (groups[k].validKeys.length > 0) {
        result.validKeys.push(groups[k].validKeys[0])
      }
      result.selectedObjects.push(groups[k].selectedObjects[0])
    })
  } else {
    result.positionText = optionalPositionTranslationCode
      ? T(optionalPositionTranslationCode)
      : T("SYSTableRowFnProcessRowFnPositions")
  }

  if (
    result.selectedObjects.length - result.validKeys.length > 0 ||
    ((fromTableFn || result.selectedObjects.length > 0) && usePrompt)
  ) {
    let systemConfirmContent
    let systemValidationContent
    let customConfirmContent
    if (result.selectedObjects.length - result.validKeys.length > 0) {
      systemValidationContent = T("SYSTableRowFnValidationInvalid", [
        fnName,
        result.positionText,
        result.selectedObjects.length,
        result.validKeys.length,
      ])
    }
    let title
    if (fromTableFn) {
      title = fnName
    } else {
      let actionKey = customFnId
      let actionName = fnName
      title = _GetTableDialogTitle(
        def,
        actionKey,
        actionName,
        selectedRows.length,
        data.data,
        result.validKeys[0],
        !!groupedByColumn
      )
    }
    if (!fromTableFn && result.validKeys.length === 0) {
      await DialogOk(html`${systemValidationContent}`, {
        title,
        type: "warning",
        instance: `${def.id}_${customFnId}`,
      })
      result.cancel = true
      return result
    } else if (result.validKeys.length > 1 && usePrompt) {
      let countHint = T(
        "SYSTableRowFnProcessRowFnHint",
        result.validKeys.length.toString()
      )
      systemConfirmContent = `${T("SYSTableRowFnConfirmMulti", [
        fnName,
        result.positionText,
        result.selectedObjects.length,
        result.validKeys.length,
        countHint,
      ])}`
    } else if ((fromTableFn || result.validKeys.length > 0) && usePrompt) {
      systemConfirmContent = T("SYSTableRowFnConfirm", [
        T(def.options.customRowActions[customFnId].translationKey),
        "",
      ])
    }
    let connectedFormBehaviour = {
      formType: undefined,
      formId: undefined,
      fieldsResetType: undefined,
    }
    let confirmRes = await _RowFnConfirmFormHelper(
      systemConfirmContent,
      systemValidationContent,
      customConfirmContent,
      customFnId,
      connectedFormBehaviour,
      def.options.customRowActions[customFnId],
      actions.app.features[def.feature],
      data,
      def,
      undefined,
      fnName,
      result.validKeys,
      selectedRows,
      undefined,
      title
    )
    result.connectedFormBehaviour = connectedFormBehaviour
    if (!confirmRes || (result.validKeys.length === 0 && !fromTableFn)) {
      result.cancel = true
    }
  }
  return result
}

export const _TableDeleteRowFromData: SYSAction<{
  key: string
  def: SYSTableDef
  data: SYSTableData
}> = (value) => {
  deleteTableRow({ data: value.data, def: value.def }, value.key)
}
